// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:16:15.912Z
// Property: Windscape at Daphne (ID: 5658182407946240)
// Collections: 28 amenities, 6 floorplans (live), 24 photos, 66 POIs, 4 reviews, 1 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "5658182407946240",
  "property_external_id": "4973403",
  "property_zillow_url": "TBD",
  "property_apartments_url": "https://www.apartments.com/dlp-daphne-apartments-daphne-al/t2nrm18",
  "property_google_business_url": "https://www.google.com/maps/place/Windscape+at+Daphne/data=!4m2!3m1!1s0x0:0x4ae2f6c0b025f234?sa=X&ved=2ahUKEwjtmu-WubySAxWqz_ACHfldGHUQ_BJ6BAgREAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321263911",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "windscape-at-daphne",
  "property_name": "Windscape at Daphne",
  "property_website_url": "https://www.windscapeatdaphne.com/",
  "property_domain": "https://www.windscapeatdaphne.com/",
  "property_address": "27670 Us-98",
  "property_full_address": "27670 US-98, Daphne, AL 36526",
  "property_address_1": "27670 US-98",
  "property_address_2": null,
  "property_address_city": "Daphne",
  "property_address_state": "AL",
  "property_address_zip_full": null,
  "property_address_zip": "36526",
  "property_address_country": "US",
  "property_address_county": "Baldwin County",
  "property_neighborhood_address": "Daphne",
  "property_address_latitude": "30.6289488",
  "property_address_longitude": "-87.9081959",
  "property_email": "windscape@rrliving.com",
  "property_phone": "+1-251-319-5876",
  "property_call_tracking_phone": "251-336-4176",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Windscape at Daphne, your dream apartment awaits among our thoughtfully designed one and two-bedroom floor plans. Enjoy a vibrant lifestyle, complete with a refreshing pool, a state-of-the-art fitness center, and a relaxing roof terrace. Your perfect home in Daphne, Alabama, is just a call away—schedule a tour today!",
  "property_long_description": "Welcome to Windscape at Daphne, your ideal retreat in the heart of Daphne, Alabama! Our vibrant apartment community offers spacious floor plans, including one and two-bedroom options designed to meet your lifestyle needs. Each apartment features modern amenities and stylish finishes that ensure comfort and convenience.\n\nAt Windscape, we believe in providing an exceptional living experience. Dive into relaxation at our refreshing pool, break a sweat in our state-of-the-art fitness center, or enjoy the convenience of on-site maintenance and concierge services. Pet lovers will appreciate our thoughtful pet care facilities, including a designated pet washing station tailored for your furry friends.\n\nOur community is designed to foster connections and elevate your daily life. Unwind at our inviting clubhouse and lounge areas, host meetings in our well-equipped conference rooms, or soak in the stunning views from the roof terrace. The outdoor cabana and courtyard provide the perfect setting for social gatherings, complete with grilling stations for your weekend cookouts.\n\nExperience the charm of Daphne, combined with the luxury of Windscape. Our engaging amenities and prime location make it easy to call us home. Don’t miss out on the opportunity to immerse yourself in a lifestyle of comfort and convenience. \n\nFind your new home today—browse our availability or schedule a tour to explore all that Windscape at Daphne has to offer! Your perfect apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019d06fa-763f-733e-962e-456fdfaec87a.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
    "public_id": "019d06fa-763f-733e-962e-456fdfaec87a",
    "storage_key": "property/5658182407946240/019d06fa-763f-733e-962e-456fdfaec87a.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "72",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.27777777777779",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "One-Time Move-In Fees\nAdministrative Fee\n$100\nApplication Fee\n$65",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "15",
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "No more than two animals are allowed per apartment. Aggressive breeds will not be allowed.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": "Dogs Allowed\nMonthly Pet Rent\n$50\nOne Time Fee\n$500\nRestrictions:\nIf animals are accepted at the RREAF Residential community where application is made, no more than two animals are allowed per apartment. Aggressive breeds will not be allowed. A non-refundable pet fee, monthly pet rent and prior approval from management will be required for each pet.\nCats Allowed\nMonthly Pet Rent\n$50\nOne Time Fee\n$500\nRestrictions:\nIf animals are accepted at the RREAF Residential community where application is made, no more than two animals are allowed per apartment. Aggressive breeds will not be allowed. A non-refundable pet fee, monthly pet rent and prior approval from management will be required for each pet.",
  "property_online_leasing_url": "https://8873224.onlineleasing.realpage.com/#k=42740",
  "property_resident_portal_url": "https://dlpdaphne.loftliving.com/login",
  "property_apply_now_url": "https://8873224.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e849a-5a7e-722d-97b9-78cde4cf636d.webp",
  "property_primary_logo_media": {
    "alt_text": "Windscape at Daphne logo",
    "public_id": "019e849a-5a7e-722d-97b9-78cde4cf636d",
    "storage_key": "property/5658182407946240/019e849a-5a7e-722d-97b9-78cde4cf636d.webp",
    "width": 1157,
    "height": 572
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e849a-5a7e-722d-97b9-78cde4cf636d.webp",
  "property_secondary_logo_media": {
    "alt_text": "Windscape at Daphne logo",
    "public_id": "019e849a-5a7e-722d-97b9-78cde4cf636d",
    "storage_key": "property/5658182407946240/019e849a-5a7e-722d-97b9-78cde4cf636d.webp",
    "width": 1157,
    "height": 572
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e8e87-c588-7672-aec7-c456b37bf8ec.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-c588-7672-aec7-c456b37bf8ec",
    "storage_key": "property/5658182407946240/019e8e87-c588-7672-aec7-c456b37bf8ec.webp",
    "width": 1157,
    "height": 572
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e8e87-bb36-7118-a1c4-428f0771627b.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-bb36-7118-a1c4-428f0771627b",
    "storage_key": "property/5658182407946240/019e8e87-bb36-7118-a1c4-428f0771627b.webp",
    "width": 1157,
    "height": 572
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "711 - 1238",
  "property_sqft_min": "711",
  "property_sqft_max": "1238",
  "property_price_range": "1100 - 1670",
  "property_price_min": "1100",
  "property_price_max": "1670",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/people/Windscape-at-Daphne/61554737393116/",
  "property_instagram_url": "https://www.instagram.com/windscapeatdaphne/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJIUDHsrhDmogRNPIlsMD24ko",
  "property_youtube_url": "https://www.youtube.com/watch?t=31&v=q4fFnwXgDqY",
  "property_yelp_url": "https://www.yelp.com/biz/windscape-daphne",
  "property_tiktok_url": "https://www.tiktok.com/@windscapeatdaphneapts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Windscape at Daphne",
  "property_home_romance_title": "Embrace Comfort and Connection in Your Ideal Apartment Home",
  "property_home_amenities_blurb": "<p>Look no further for a place that feels like home. Windscape at Daphne's <a href=\"/floor-plans/\">spacious apartments</a> are designed for quality, comfort, and convenience. Our apartments are ideally in Daphne, AL near Mobile Bay, Bayfront Park, Alabama State University, Infirmary Health, and <a href=\"/neighborhood/\">more</a>. <a href=\"/virtual-tour/\">Tour today!</a></p>",
  "property_home_floorplans_blurb": "<p>Located in Daphne, AL, we offer stunning <a href=\"/floor-plans/\">1- and 2- bedroom</a> apartment homes with open floorplans, contemporary design, and <a href=\"/amenities/\">stylish finishes</a>. Windscape at Daphne is more than just a place to live, it is a lifestyle.</p>",
  "property_home_gallery_blurb": "At Windscape at Daphne, immerse yourself in a pet-friendly haven adorned with beautiful landscaping and mature shade trees. Enjoy modern amenities like energy-efficient appliances, a shimmering pool, and vibrant resident events. With stylish floor plans and a welcoming community, your ideal lifestyle awaits. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Daphne, Windscape at Daphne offers inviting one and two-bedroom apartments surrounded by vibrant local charm. Experience the best of coastal living with delightful dining, shopping, and parks just moments away. Dive into the community's unique treasures and uncover your new favorite spots today!",
  "property_home_reviews_blurb": "Welcome to Windscape at Daphne, where community meets comfort in the heart of Alabama. Residents rave about our spacious apartments, with one noting, \"You can’t find an apartment in this area as spacious as these are.\" Experience top-notch service from our dedicated manager, Theresa, who truly cares for our residents. Join us!",
  "property_neighborhood_blurb": "<p>Located in Daphne, AL, we offer stunning <a href=\"/floor-plans/\">1- and 2- bedroom</a> apartment homes with open floorplans, contemporary design, and <a href=\"/amenities/\">stylish finishes</a>. Windscape at Daphne is more than just a place to live, it is a lifestyle.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Windscape at Daphne in Daphne, AL offers stunning apartment features and amenities. Our <a href=\"/floor-plans/\">spacious apartments</a> for rent include spacious walk-in closets, cozy fireplace, and a balcony or patio. On those hot summer days enjoy the shimmering swimming pool with sundeck, gather in the resident clubhouse and business center, and easy access to freeways and shopping. Everything you need and want is right here at our beautiful apartment <a href=\"/neighborhood/\">community</a>.</p>",
  "property_applynow_blurb": "At Windscape at Daphne, your ideal lifestyle awaits in a vibrant community featuring spacious one and two-bedroom floor plans. Enjoy sunny afternoons by the pool, energize in the fitness center, or unwind on the stunning roof terrace. Secure your perfect home today—leasing is just a click away!",
  "property_contactus_blurb": "At Windscape at Daphne in picturesque Daphne, Alabama, choose from thoughtfully designed one and two-bedroom floor plans that perfectly blend comfort and style. Our vibrant community awaits your inquiry. Have questions? Reach out to our leasing team today for personalized assistance in finding your ideal home!",
  "property_faqs_blurb": "At Windscape at Daphne, we offer thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Nestled in scenic Daphne, Alabama, our community prioritizes your comfort. Curious about what we offer? Visit our FAQs page to uncover the answers to your most pressing questions about life here.",
  "property_floorplans_blurb": "<p>Come home to your cozy and bright one or two bedroom apartment for rent in Daphne, AL, with open and inviting floor plans designed with contemporary elegance. Select from custom features that include built-in bookshelves, designer cabinets, a fireplace, and granite countertops. There are many <a href=\"/amenities/\">premium amenities</a> to choose from, and there are some for your pets, too! Bring the whole family to the pet-friendly Windscape at Daphne and enjoy the walking trails and yappy hours!</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At Windscape at Daphne, choose from stylish one and two-bedroom floor plans that fit your lifestyle. Enjoy premium amenities like a refreshing pool, a state-of-the-art fitness center, and a charming roof terrace. Use our interactive community map to find your perfect home in the heart of Daphne, Alabama!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Windscape at Daphne, where community thrives, your perfect home awaits! Choose between our spacious one-bedroom and two-bedroom layouts to suit your lifestyle. Great friends make great neighbors—refer a friend today and share the vibrant charm of Daphne living! Together, you'll enjoy all our community has to offer.",
  "property_residentaccess_blurb": "Welcome to Windscape at Daphne, where comfort meets convenience in beautiful Daphne, Alabama. With diverse floor plans, including spacious one- and two-bedroom options, we cater to your lifestyle needs. Access your resident portal now to effortlessly manage rent payments, schedule maintenance, and enjoy a hassle-free living experience!",
  "property_reviews_blurb": "Nestled in the heart of Daphne, Windscape at Daphne offers a nurturing community where residents truly feel at home. With spacious apartments featuring inviting plank floors and cozy fireplaces, your comfort is our priority. As one resident shares, \"Theresa has been the longest standing and best manager we’ve ever had,\" ensuring a welcoming experience for all.",
  "property_created_at": "1752256420898",
  "property_scheduletour_blurb": "At Windscape at Daphne, immerse yourself in thoughtfully designed one and two-bedroom floor plans tailored for comfort. Nestled in scenic Daphne, Alabama, our vibrant community offers more than just a home—it's a lifestyle. Schedule a tour today and hear firsthand why our residents love calling Windscape home!",
  "property_thankyou_blurb": "Thank you for reaching out to Windscape at Daphne! Nestled in the heart of Daphne, Alabama, our charming community offers spacious one and two-bedroom floor plans designed for comfortable living. A member of our team will connect with you soon to help you find your perfect home!",
  "property_virtualtours_blurb": "<p>At Windscape at Daphne, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Windscape at Daphne",
  "property_seo_title_home": "Windscape at Daphne | Apartments in Daphne, Alabama",
  "property_seo_description_home": "Embrace the lifestyle you deserve at Windscape at Daphne, where modern comfort meets Southern charm. Our thoughtfully designed one and two-bedroom apartments offer spacious living paired with exceptional amenities, including a refreshing pool, a state-of-the-art fitness center, and serene roof terrace views. Enjoy the convenience of on-site maintenance, pet-friendly spaces, and a vibrant clubhouse for social gatherings. Nestled in the heart of Daphne, Alabama, your perfect home awaits amidst lush courtyards and inviting cabanas. Start your journey to a new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Daphne, Alabama",
  "property_seo_description_floorplans": "Unveil modern comfort at Windscape at Daphne, where stylish living meets Southern charm. Whether you need a cozy one-bedroom retreat or a spacious two-bedroom haven, our thoughtfully designed floor plans cater to your lifestyle. Embrace the tranquility of Daphne, Alabama, and explore our diverse options—your dream apartment awaits. Browse our available homes today!",
  "property_seo_title_amenities": "Amenities | Daphne, Alabama Apartments for Rent",
  "property_seo_description_amenities": "Unwind in style at Windscape at Daphne, where modern living meets exceptional comfort in the heart of Alabama. Choose from spacious one and two-bedroom floor plans that suit your lifestyle, and indulge in amenities designed for relaxation and convenience. Whether you're lounging by the sparkling pool, breaking a sweat in our state-of-the-art fitness center, or enjoying sunset views from the roof terrace, every day offers a new experience. For pet lovers, our dedicated pet care facilities ensure your furry friends feel at home too. Dive into our vibrant community today!",
  "property_seo_title_gallery": "Gallery | Apartments in Daphne, Alabama",
  "property_seo_description_gallery": "\"Picture yourself living at Windscape at Daphne, where modern comfort meets Southern charm. Our stunning photo gallery showcases spacious one and two-bedroom apartments adorned with premium amenities. Dive into relaxation by the sparkling pool, stay active in our well-equipped fitness center, and unwind at the rooftop terrace with breathtaking views. Enjoy the convenience of on-site maintenance, pet care services, and a vibrant clubhouse. Explore every corner of your future home in Daphne, Alabama, and imagine the lifestyle that awaits. Your dream apartment is just a click away!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Windscape at Daphne Apartments",
  "property_seo_description_virtualtours": "Step into your dream home at Windscape at Daphne in beautiful Daphne, Alabama. Whether you're seeking a cozy one-bedroom retreat or a spacious two-bedroom haven, our thoughtfully designed floor plans cater to every lifestyle. Experience the charm and comfort of our community—take a virtual tour today and envision your next chapter with us!",
  "property_seo_title_interactivemap": "Interactive Map | Windscape at Daphne Apartments",
  "property_seo_description_interactivemap": "Experience the charm of Windscape at Daphne in beautiful Alabama, where modern living meets unmatched comfort. Choose your perfect home from our spacious one- and two-bedroom floor plans, and enjoy top-tier amenities like a refreshing pool, a state-of-the-art fitness center, and relaxing cabanas. With on-site pet care and a thorough dog washing station, your furry friends will love it here too! Use our interactive community map to find your ideal apartment, explore pricing, and turn your dream of upscale living into reality. Welcome home to Windscape!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Daphne, Alabama",
  "property_seo_description_neighborhood": "Uncover the vibrant charm of Daphne, Alabama, right from Windscape at Daphne! Nestled in a lively neighborhood, our community offers easy access to local favorites and hidden gems. Whether you choose a spacious one or two-bedroom apartment, enjoy the perfect blend of comfort and convenience. Click to see what's around our community and dive into the lively culture waiting just outside your door!",
  "property_seo_title_contact": "Contact Us | Windscape at Daphne",
  "property_seo_description_contact": "Looking for your ideal apartment in Daphne, Alabama? Windscape at Daphne offers spacious one and two-bedroom floor plans tailored to your lifestyle. Our friendly leasing team is ready to assist you with any questions. Reach out today and start your journey home!",
  "property_seo_title_faqs": "FAQs | Apartments in Daphne, Alabama",
  "property_seo_description_faqs": "Uncover the unique lifestyle awaiting you at Windscape at Daphne, where luxury meets comfort in the heart of Alabama. With thoughtfully designed one and two-bedroom floor plans and an array of lavish amenities—from a sun-drenched pool and state-of-the-art fitness center to pet care services and a rooftop terrace—your perfect home is just a click away. Have questions? Browse our FAQs page for insights into our vibrant community and the exceptional living experience we provide.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Daphne, Alabama",
  "property_seo_description_reviews": "Uncover the lifestyle waiting for you at Windscape at Daphne, where residents revel in spacious one- and two-bedroom apartments adorned with premium amenities. Dive into our resort-style pool, stay fit in the state-of-the-art fitness center, or relax in our chic lounge and inviting clubhouse. With a pet care facility, a scenic roof terrace, and dedicated conference rooms, our community blends luxury, convenience, and comfort perfectly. Curious about the resident experience? Read their reviews and see what makes Windscape at Daphne the ideal home in beautiful Daphne, Alabama!",
  "property_seo_title_applynow": "Apply Now | Apartments in Daphne, Alabama",
  "property_seo_description_applynow": "Uncover a life of luxury at Windscape at Daphne, where every detail is designed with your comfort in mind. Choose from spacious one or two-bedroom floor plans and indulge in top-notch amenities including a refreshing pool, modern fitness center, and a stunning roof terrace perfect for sunset views. With a dedicated concierge, pet care services, and a vibrant clubhouse, every day feels like a retreat. Ready to elevate your living experience? Find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Windscape at Daphne",
  "property_seo_description_residentaccess": "\"Welcome to the Windscape at Daphne resident portal—your convenient gateway to effortless living in Alabama. Log in to manage rent payments, schedule maintenance, and connect with our vibrant community. Your comfort is just a click away!\"",
  "property_seo_title_referafriend": "Refer A Friend | Windscape at Daphne",
  "property_seo_description_referafriend": "\"Windscape at Daphne invites you to strengthen our vibrant community! Share the joys of stylish living in sunny Alabama by referring a friend today—because great friends make great neighbors!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Windscape at Daphne",
  "property_seo_description_scheduletour": "\"Experience the serene lifestyle at Windscape at Daphne, where lush landscapes meet modern living. Ready to find your dream home? Schedule a personalized tour today and see why our community is the perfect place to call home!\"",
  "property_seo_title_privacy": "Privacy Policy | Windscape at Daphne",
  "property_seo_description_privacy": "\"At Windscape at Daphne, your comfort and security are our top priorities. Dive into our privacy policy to understand how we protect your information while you enjoy peaceful living in the heart of Daphne, Alabama. Your privacy matters to us!\"",
  "property_seo_title_accessibility": "Website Accessibility | Windscape at Daphne",
  "property_seo_description_accessibility": "\"At Windscape at Daphne, we embrace digital inclusivity by ensuring our community is accessible to everyone. Dive into our commitment to seamless navigation and enhanced accessibility features designed for all residents. Your comfort and convenience matter—let us show you how we make every experience a breeze.\"",
  "property_seo_title_sitemap": "Sitemap | Windscape at Daphne",
  "property_seo_description_sitemap": "\"Navigate your way through Windscape at Daphne, where modern living meets Southern charm. Our sitemap offers a clear path to discover amenities, floor plans, and community features in beautiful Daphne, Alabama. Dive in and find your perfect home today!\"",
  "property_seo_title_thankyou": "Thank You | Windscape at Daphne",
  "property_seo_description_thankyou": "Thank you for reaching out to Windscape at Daphne! Your interest in our vibrant community near the beautiful shores of Alabama is greatly appreciated. Our team will be in touch soon to help you find your perfect home. Stay tuned for updates and let the journey to your new lifestyle begin!",
  "property_seo_title_pets": "Pet Policy | Apartments in Daphne, Alabama",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293558128",
  "amenities": [
    {
      "id": "custom_244fe561-a3db-480c-bdff-29c145427c0c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Beautiful Landscaping with Mature Shade Trees",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f464024f-0a4d-40ac-bd75-c475e8e63495",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Complimentary Wi‑Fi in Common Areas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_29afdd50-e325-4143-a676-7f2a480e82cb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to Freeways and Shopping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f1a854f9-5ea9-4a98-8182-2b4997ca50f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "On‑site Resident Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a667e095-8945-4542-8372-58842af4909a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Online Resident Portal with FLEX‑Flexible Payment Options",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_42c78746-a9b8-429b-89f2-dca7a56e43a8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Pet‑friendly Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_610d2ef1-a27f-4ea6-9431-c8a76a12e2e2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Picnic Areas and Grilling Stations",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_64d1e7f3-a60e-4b30-af47-9312bf552ed7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Professional On‑site Maintenance and Management Teams",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_57dd9514-145c-436f-a305-843e699e6562",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fbe7e395-ff12-4ce4-865c-4fc4c374f2a8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aa0b222f-a910-4073-b3f0-aa9bb9f9ce84",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Shimmering Swimming Pool with Sundeck",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_040fe47d-24b2-4f6d-ba8e-61201acb08fd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Tranquil Courtyard with Gazebo",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cc71f646-c3ab-440b-bec7-ad312e43ea74",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "All‑electric Kitchen with Energy‑efficient Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ccf8b3d2-b532-401e-92e4-5349ea06697e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony or Patio",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8f2d21fa-b6c2-4752-9a54-b33d7c80e03c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Built‑in Bookshelves*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5026cf79-eac3-4fec-9938-c87c6d464bb7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f6446f7a-18d8-40a1-ad09-e2c38a131118",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_95e9b25d-338c-49fa-bb10-f6b7e72c3d30",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Cozy Fireplace*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6670c452-6db2-4a0d-9627-0afe7a02902d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Custom Cabinetry*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f5ec6292-d95f-42d5-8cbc-0597117eb1bb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Designer Wood‑style Flooring*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6bd11b9f-432a-45e5-9508-be86b9a092b9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher and Built‑in Microwave",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c4656bce-53a7-4a7e-8c65-1d2f443423f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Granite Countertops*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d1aa8e02-37f7-4762-89fc-8f37cbc8a25d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Open Concept Living Areas",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dea80e9a-498d-41fd-8ab6-54096012f5e2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Smart Outlets with USB Charging*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dc25050f-83b0-40b7-826f-8f54ad8c88be",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Walk‑in Closets*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_407ac61b-7119-48d8-bb93-23d9b779238f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Tile Backsplash*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e4c1598e-38ec-42e4-8e85-6273bb6dbdfa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_10754aa8-7341-4536-b0ae-5d639da50500",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer Connections",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_b4213ecb-3205-45f9-8077-6b7c127c37bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e849a-6f14-713d-9b95-d93bfd247cae.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and fireplace.",
        "public_id": "019e849a-6f14-713d-9b95-d93bfd247cae",
        "storage_key": "property/5658182407946240/019e849a-6f14-713d-9b95-d93bfd247cae.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This living room features a comfortable sofa, an accent armchair, and a cozy fireplace, perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Living room with a sofa, armchair, coffee table, and fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_121360f7-3454-49a9-ba28-7065d7f2b399",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e849a-5bed-730c-b783-c4aba0df4cdf.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, black appliances, and subway tile backsplash.",
        "public_id": "019e849a-5bed-730c-b783-c4aba0df4cdf",
        "storage_key": "property/5658182407946240/019e849a-5bed-730c-b783-c4aba0df4cdf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a beautifully updated kitchen featuring sleek black appliances, ample cabinet space, and elegant granite countertops, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, black appliances, and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d147e094-726b-49f6-87fa-c9d64954eff0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/01a09230-bff9-77dc-aad6-d9490f4e6458.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees surrounding the apartment buildings.",
        "public_id": "01a09230-bff9-77dc-aad6-d9490f4e6458",
        "storage_key": "property/5658182407946240/01a09230-bff9-77dc-aad6-d9490f4e6458.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush landscaping and tall trees. Relax on the comfortable lounge chairs and soak up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and trees surrounding the apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa62c863-5370-42c5-a750-9cdac34602fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/01a09230-bd00-75c9-ba74-5657dbee3f9c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo in a residential complex.",
        "public_id": "01a09230-bd00-75c9-ba74-5657dbee3f9c",
        "storage_key": "property/5658182407946240/01a09230-bd00-75c9-ba74-5657dbee3f9c.webp",
        "width": 1500,
        "height": 999
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush greenery and comfortable seating areas. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo in a residential complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_014c92f5-eb72-4107-afe0-e3ed6fe2a114",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/01a09230-bce3-707a-9bae-0dd5721dd55a.webp",
      "image_media": {
        "alt_text": "Covered outdoor seating area with table and blue chairs.",
        "public_id": "01a09230-bce3-707a-9bae-0dd5721dd55a",
        "storage_key": "property/5658182407946240/01a09230-bce3-707a-9bae-0dd5721dd55a.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy the outdoors in this shaded seating area, perfect for relaxing or gathering with friends.",
      "link": "",
      "alt_text": "Covered outdoor seating area with table and blue chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c6e42341-db66-4456-871f-d0b41a311106",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/01a09230-bcdd-70bc-8840-907d3bf42001.webp",
      "image_media": {
        "alt_text": "Spacious living room with a fireplace, large windows, and comfortable seating.",
        "public_id": "01a09230-bcdd-70bc-8840-907d3bf42001",
        "storage_key": "property/5658182407946240/01a09230-bcdd-70bc-8840-907d3bf42001.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Relax and unwind in this inviting living room, featuring a cozy fireplace and ample natural light from large windows.",
      "link": "",
      "alt_text": "Spacious living room with a fireplace, large windows, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2b3818a0-2e1d-453f-b4ab-8b90d69b04fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/01a09230-b6ea-70ff-9d58-a7bdeba4889f.webp",
      "image_media": {
        "alt_text": "Windscape at Daphne Apartment Homes monument sign",
        "public_id": "01a09230-b6ea-70ff-9d58-a7bdeba4889f",
        "storage_key": "property/5658182407946240/01a09230-b6ea-70ff-9d58-a7bdeba4889f.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Welcome to Windscape at Daphne Apartment Homes. Visit us at windscapeatdaphne.com or call 27670.",
      "link": "",
      "alt_text": "Windscape at Daphne Apartment Homes monument sign",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d42f0122-000c-4370-a368-cfe2e8e9ac88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/01a09230-a975-72a6-9663-13ff7ad3c4d6.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with pathways and trees.",
        "public_id": "01a09230-a975-72a6-9663-13ff7ad3c4d6",
        "storage_key": "property/5658182407946240/01a09230-a975-72a6-9663-13ff7ad3c4d6.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds surround these apartment buildings, featuring pathways, lush greenery, and mature trees.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with pathways and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_36f9794e-c719-4aa7-bc6d-c97df648faa2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/01a09230-a404-71af-8a29-874f3258e2e7.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with lush green landscaping and a winding walkway.",
        "public_id": "01a09230-a404-71af-8a29-874f3258e2e7",
        "storage_key": "property/5658182407946240/01a09230-a404-71af-8a29-874f3258e2e7.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Exterior view of a charming apartment building surrounded by mature trees and manicured lawns, featuring a scenic pathway leading to the entrance.",
      "link": "",
      "alt_text": "Apartment building exterior with lush green landscaping and a winding walkway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a5f4d78a-a3ec-4645-a7dd-339871f046c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/01a09230-a409-7550-bf8e-15f19b2e38a0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a gazebo surrounded by trees.",
        "public_id": "01a09230-a409-7550-bf8e-15f19b2e38a0",
        "storage_key": "property/5658182407946240/01a09230-a409-7550-bf8e-15f19b2e38a0.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and a charming gazebo. Enjoy the sunny weather and tranquil atmosphere.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a gazebo surrounded by trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c1f5de18-8e54-4b5e-a9e4-cf991dfd4676",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/01a09230-a3fe-773f-aa7e-2c32641e0ca8.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with two built-in grills and stone accents",
        "public_id": "01a09230-a3fe-773f-aa7e-2c32641e0ca8",
        "storage_key": "property/5658182407946240/01a09230-a3fe-773f-aa7e-2c32641e0ca8.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with our community's state-of-the-art outdoor kitchen, featuring multiple grills and ample prep space.",
      "link": "",
      "alt_text": "Outdoor kitchen with two built-in grills and stone accents",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fc5fc550-740f-4faa-8bef-7a2222bbf4cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/01a09230-a50e-7195-8186-f273aa4fb8ae.webp",
      "image_media": {
        "alt_text": "Community lounge area with seating, coffee table, and fireplace.",
        "public_id": "01a09230-a50e-7195-8186-f273aa4fb8ae",
        "storage_key": "property/5658182407946240/01a09230-a50e-7195-8186-f273aa4fb8ae.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Relax and unwind in our spacious community lounge, featuring comfortable seating, a cozy fireplace, and a stylish coffee table.",
      "link": "",
      "alt_text": "Community lounge area with seating, coffee table, and fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c2798bd1-c142-4ea5-b75c-6d6df70ddcea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e849a-5dbe-75cb-9f5b-e190234ff19e.webp",
      "image_media": {
        "alt_text": "Bedroom with king-size bed, dresser, nightstands, and blue accents.",
        "public_id": "019e849a-5dbe-75cb-9f5b-e190234ff19e",
        "storage_key": "property/5658182407946240/019e849a-5dbe-75cb-9f5b-e190234ff19e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed with decorative pillows, elegant nightstands, and ample dresser storage. The room is complemented by soothing wall colors and tasteful decor.",
      "link": "",
      "alt_text": "Bedroom with king-size bed, dresser, nightstands, and blue accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0ecd53fa-5f32-404f-98ed-6a385edb6dde",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e849a-5cfd-77cb-968f-d8ee95f678c5.webp",
      "image_media": {
        "alt_text": "Bedroom with a daybed, desk, and ceiling fan.",
        "public_id": "019e849a-5cfd-77cb-968f-d8ee95f678c5",
        "storage_key": "property/5658182407946240/019e849a-5cfd-77cb-968f-d8ee95f678c5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable daybed, a functional desk, and stylish decor, perfect for relaxation or work.",
      "link": "",
      "alt_text": "Bedroom with a daybed, desk, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9300a605-1ca4-4529-9329-0fff90231d32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e849a-7652-742a-9a72-88bd6fc7f556.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019e849a-7652-742a-9a72-88bd6fc7f556",
        "storage_key": "property/5658182407946240/019e849a-7652-742a-9a72-88bd6fc7f556.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3e244d0c-c2c9-4089-a1c2-b7892113e75e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e849a-7292-715d-9bad-9ada9f215afa.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with two built-in grills under a wooden pergola.",
        "public_id": "019e849a-7292-715d-9bad-9ada9f215afa",
        "storage_key": "property/5658182407946240/019e849a-7292-715d-9bad-9ada9f215afa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor dining with our community's shared outdoor kitchen, featuring two spacious grills perfect for entertaining guests.",
      "link": "",
      "alt_text": "Outdoor kitchen with two built-in grills under a wooden pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7fe362d3-9ef0-4a9a-862e-e9c00b86159e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e849a-68d5-7648-88c3-168335ad2140.webp",
      "image_media": {
        "alt_text": "Dining area adjacent to a kitchen, with a wooden table set for four.",
        "public_id": "019e849a-68d5-7648-88c3-168335ad2140",
        "storage_key": "property/5658182407946240/019e849a-68d5-7648-88c3-168335ad2140.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright dining area with a rustic wooden table set for four, opening to a modern kitchen with white cabinets and granite countertops.",
      "link": "",
      "alt_text": "Dining area adjacent to a kitchen, with a wooden table set for four.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_de6ba590-965d-43ad-9b43-1143c136b239",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e849a-5c39-72fe-b024-2de86b9fbdcd.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan, closet, and view into bathroom.",
        "public_id": "019e849a-5c39-72fe-b024-2de86b9fbdcd",
        "storage_key": "property/5658182407946240/019e849a-5c39-72fe-b024-2de86b9fbdcd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, ample closet space, and a connecting bathroom. Enjoy comfortable living in this well-appointed apartment.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan, closet, and view into bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f6819a8b-1e9d-4fe3-afb6-48c045d3b635",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e849a-5bf8-76c4-a872-103f225cd01a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with a granite countertop.",
        "public_id": "019e849a-5bf8-76c4-a872-103f225cd01a",
        "storage_key": "property/5658182407946240/019e849a-5bf8-76c4-a872-103f225cd01a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Refresh and unwind in this bright and airy bathroom, featuring a spacious vanity with granite countertops and a soothing tub-shower combo.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with a granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2ea03074-be64-409f-b11a-17e86364e64c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e849a-5ac2-760d-b246-5665e805e80b.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and kitchen view",
        "public_id": "019e849a-5ac2-760d-b246-5665e805e80b",
        "storage_key": "property/5658182407946240/019e849a-5ac2-760d-b246-5665e805e80b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with a cozy fireplace and an open kitchen, perfect for entertaining guests.",
      "link": "",
      "alt_text": "Living room with fireplace and kitchen view",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8e2dcde1-9474-4a6e-8874-9de127587e6e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e849a-5b51-767b-93c7-b9c6ece0d723.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and adjacent kitchen.",
        "public_id": "019e849a-5b51-767b-93c7-b9c6ece0d723",
        "storage_key": "property/5658182407946240/019e849a-5b51-767b-93c7-b9c6ece0d723.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace and an adjacent open-concept kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with fireplace and adjacent kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8dc1b1d0-5fce-4565-9c1b-8a514e19b72f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e849a-5ee9-739b-9af1-2e9753af05a0.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs, tables, umbrellas, and grills, adjacent to apartment buildings and a gazebo.",
        "public_id": "019e849a-5ee9-739b-9af1-2e9753af05a0",
        "storage_key": "property/5658182407946240/019e849a-5ee9-739b-9af1-2e9753af05a0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush landscaping and convenient amenities like grilling stations and comfortable seating.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs, tables, umbrellas, and grills, adjacent to apartment buildings and a gazebo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_51b6573c-7ffa-4655-bb22-a3ae6d4ee5af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e849a-7fba-71ca-a6f3-025e5f41d575.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and surrounding trees.",
        "public_id": "019e849a-7fba-71ca-a6f3-025e5f41d575",
        "storage_key": "property/5658182407946240/019e849a-7fba-71ca-a6f3-025e5f41d575.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully maintained apartment exteriors surrounded by lush greenery and mature trees, offering a serene living environment.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and surrounding trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9df3773e-eb1b-4175-afde-e36b4aa7dd56",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e849a-5a59-745d-9625-c9f86bcd2d26.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a ceiling fan and a window.",
        "public_id": "019e849a-5a59-745d-9625-c9f86bcd2d26",
        "storage_key": "property/5658182407946240/019e849a-5a59-745d-9625-c9f86bcd2d26.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom with wood-style flooring, a ceiling fan, and a large window. Perfect for personalizing your living space.",
      "link": "",
      "alt_text": "Empty bedroom with a ceiling fan and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_8caf34b1-cc73-4cc0-8611-0b4ea33e0519",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Soul Caffeine",
      "poi_type": "Restaurants",
      "poi_address": "2004 US-98 B, Daphne, AL 36526, USA",
      "poi_short_description": "Coffee shop attracting customers with pastries, lattes, and a cozy atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4a-fc96-70ad-b26e-4110b2bf1b91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4a-fc96-70ad-b26e-4110b2bf1b91",
        "storage_key": "property/5658182407946240/019e1e4a-fc96-70ad-b26e-4110b2bf1b91.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://www.facebook.com/SoulCaffeine/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10938168995443010113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "soul-caffeine",
      "poi_latitude": "30.60713",
      "poi_longitude": "-87.89773",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 251-345-4156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-5596-74de-9657-88472b10c34e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e4b-5596-74de-9657-88472b10c34e",
        "storage_key": "property/5658182407946240/019e1e4b-5596-74de-9657-88472b10c34e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJZe8XQdRDmogRQWqSmr8uzJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_5583d4ca-5df8-4993-9810-45765823d750",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Glazed Doughnuts",
      "poi_type": "Restaurants",
      "poi_address": "2200 US-98 #5a, Daphne, AL 36526, USA",
      "poi_short_description": "Doughnut, pastry and coffee shop boasting a variety of doughnut styles plus kolaches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-0097-734c-ab35-56959b293fe6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-0097-734c-ab35-56959b293fe6",
        "storage_key": "property/5658182407946240/019e1e4b-0097-734c-ab35-56959b293fe6.webp",
        "width": 963,
        "height": 1280
      },
      "poi_business_url": "http://www.facebook.com/glazeddoughnutsdaphne",
      "poi_directions_map_url": "https://maps.google.com/?cid=7737648118308205636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glazed-doughnuts",
      "poi_latitude": "30.609833",
      "poi_longitude": "-87.8989057",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 251-586-8180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e30b-777a-91f3-9f3e34b7169c",
        "storage_key": "property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRS8nP9dDmogRRPS6wPelYWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "custom_dab32e3d-548e-4e8b-b31a-85905efa5ffe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Taziki's Mediterranean Cafe - Daphne",
      "poi_type": "Restaurants",
      "poi_address": "1539 US-98, Daphne, AL 36526, USA",
      "poi_short_description": "Comfy chain eatery providing made-to-order gyros & other Mediterranean dishes plus beer & wine.",
      "poi_long_description": "Comfy chain eatery providing made-to-order gyros & other Mediterranean dishes plus beer & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4a-fb94-778a-ac4c-cf1641721f10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4a-fb94-778a-ac4c-cf1641721f10",
        "storage_key": "property/5658182407946240/019e1e4a-fb94-778a-ac4c-cf1641721f10.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.tazikis.com/location/daphne",
      "poi_directions_map_url": "https://maps.google.com/?cid=18385784253574109641&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tazikis-mediterranean-cafe---daphne",
      "poi_latitude": "30.600763",
      "poi_longitude": "-87.89885",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-273-3337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e30b-777a-91f3-9f3e34b7169c",
        "storage_key": "property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRYHhNldAmogRyVlB111tJ_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_87d529f2-059e-4a48-a5a7-cd4ebbd15376",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Southwood Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "1203 US-98 E suite 3-d, Daphne, AL 36526, USA",
      "poi_short_description": "American fare with area-sourced ingredients & cocktails are served at this down-to-earth choice.",
      "poi_long_description": "American fare with area-sourced ingredients & cocktails are served at this down-to-earth choice.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-05ff-73cd-aef1-1d53acb7a3f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-05ff-73cd-aef1-1d53acb7a3f4",
        "storage_key": "property/5658182407946240/019e1e4b-05ff-73cd-aef1-1d53acb7a3f4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.southwoodkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1441856323024537274&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southwood-kitchen",
      "poi_latitude": "30.595437",
      "poi_longitude": "-87.8987918",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-626-6676",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e30b-777a-91f3-9f3e34b7169c",
        "storage_key": "property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3yigZHlBmogRukYHv6-AAhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_215cc575-1067-4716-ac36-4fdd36e8b27f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Sugar Kettle Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1015 Daphne Ave, Daphne, AL 36526, USA",
      "poi_short_description": "Casual establishment offering breakfast fare, seafood and sandwiches, along with fried chicken.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4a-fb79-707c-9341-5b8056cf457d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4a-fb79-707c-9341-5b8056cf457d",
        "storage_key": "property/5658182407946240/019e1e4a-fb79-707c-9341-5b8056cf457d.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.sugarkettlecafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17978696914683805331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sugar-kettle-cafe",
      "poi_latitude": "30.6041616",
      "poi_longitude": "-87.89527439999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-626-5657",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-5596-74de-9657-88472b10c34e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e4b-5596-74de-9657-88472b10c34e",
        "storage_key": "property/5658182407946240/019e1e4b-5596-74de-9657-88472b10c34e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJJb8Jd9VDmogRk74jtJYpgfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_c8ceae87-c7b8-4cca-863f-5605cd7baa25",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "East Shore Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1506 Main St, Daphne, AL 36526, USA",
      "poi_short_description": "Southern-inspired  breakfast & lunch fare served in a warm cottage with old-fashioned decor.",
      "poi_long_description": "Southern-inspired  breakfast & lunch fare served in a warm cottage with old-fashioned decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4a-ff59-741a-8dd4-757c7ec750d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4a-ff59-741a-8dd4-757c7ec750d7",
        "storage_key": "property/5658182407946240/019e1e4a-ff59-741a-8dd4-757c7ec750d7.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10777151651417425400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-shore-cafe",
      "poi_latitude": "30.600402",
      "poi_longitude": "-87.90249159999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-625-0055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e30b-777a-91f3-9f3e34b7169c",
        "storage_key": "property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJxJdGH1BmogR-AVAwVMikJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_4fcd1920-1c9c-43e2-93ed-355d5bcbbfaa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Le Bouchon",
      "poi_type": "Restaurants",
      "poi_address": "1903 Main St, Daphne, AL 36526, USA",
      "poi_short_description": "Casual wine bar (pizza and flatbreads also served) featuring a large selection of vino and bites.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-028a-75ab-8352-966667595bdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-028a-75ab-8352-966667595bdb",
        "storage_key": "property/5658182407946240/019e1e4b-028a-75ab-8352-966667595bdb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lebouchon.biz/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11440472671014706175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "le-bouchon",
      "poi_latitude": "30.6050014",
      "poi_longitude": "-87.90302950000002",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 251-340-2812",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-55b1-74b2-a65f-876dfe009bd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e4b-55b1-74b2-a65f-876dfe009bd9",
        "storage_key": "property/5658182407946240/019e1e4b-55b1-74b2-a65f-876dfe009bd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYWialtdDmogR_1tlske5xJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "custom_87f64ea6-6354-4e4b-a526-baa92b0fffc9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Daruma Japanese Sushi & Steak House",
      "poi_type": "Restaurants",
      "poi_address": "27955 U.S. 98 Suite S-T, Daphne, AL 36526, USA",
      "poi_short_description": "Easygoing Japanese spot for teriyaki, tempura & other familiar dishes, plus creative sushi rolls.",
      "poi_long_description": "Easygoing Japanese spot for teriyaki, tempura & other familiar dishes, plus creative sushi rolls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-0463-77d3-987f-29f0a3b94910.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-0463-77d3-987f-29f0a3b94910",
        "storage_key": "property/5658182407946240/019e1e4b-0463-77d3-987f-29f0a3b94910.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://darumasteaktogo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11936482793378168033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daruma-japanese-sushi--steak-house",
      "poi_latitude": "30.631201",
      "poi_longitude": "-87.9138791",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-626-8886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e30b-777a-91f3-9f3e34b7169c",
        "storage_key": "property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_wxmAtBmogR4TzevtvnpqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_3f0eb75e-640f-4b9f-8528-2b909bf34e6f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Kravers Seafood Daphne",
      "poi_type": "Restaurants",
      "poi_address": "25965 State Hwy 181, Daphne, AL 36526, USA",
      "poi_short_description": "Simple, bayou-inspired seafood spot with po' boys, combo baskets & steamed, grilled & fried catches.",
      "poi_long_description": "Simple, bayou-inspired seafood spot with po' boys, combo baskets & steamed, grilled & fried catches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-03ac-70e9-966e-bcaac80c5562.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-03ac-70e9-966e-bcaac80c5562",
        "storage_key": "property/5658182407946240/019e1e4b-03ac-70e9-966e-bcaac80c5562.webp",
        "width": 960,
        "height": 960
      },
      "poi_business_url": "https://kravers-seafood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2666678704756012922&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kravers-seafood-daphne",
      "poi_latitude": "30.602889",
      "poi_longitude": "-87.8524903",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 251-625-1990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e30b-777a-91f3-9f3e34b7169c",
        "storage_key": "property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnURpcf9pmogRercUPyfyASU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_5113ceeb-7682-4494-bbab-c1ae02a5cc21",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Boudreaux's Cajun Grill",
      "poi_type": "Restaurants",
      "poi_address": "29249 US-98, Daphne, AL 36526, USA",
      "poi_short_description": "Chill waterfront bar/eatery with Cajun seafood & steak mains, a covered deck & Sunday brunch.",
      "poi_long_description": "Chill waterfront bar/eatery with Cajun seafood & steak mains, a covered deck & Sunday brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4a-fe15-76fb-8b41-3c39fd82dba1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4a-fe15-76fb-8b41-3c39fd82dba1",
        "storage_key": "property/5658182407946240/019e1e4a-fe15-76fb-8b41-3c39fd82dba1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.boudreauxscajungrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16174688706992245458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boudreauxs-cajun-grill",
      "poi_latitude": "30.6511128",
      "poi_longitude": "-87.9135142",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-621-1991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e30b-777a-91f3-9f3e34b7169c",
        "storage_key": "property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk6PTHgtDmogR0orLjK4JeOA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_68fb8622-1a42-4480-9c18-66740c6ad774",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Yinzers Brew & Grill",
      "poi_type": "Restaurants",
      "poi_address": "28850 US-98 #200, Daphne, AL 36526, USA",
      "poi_short_description": "American sports bar & grill with some arcade game machines serving tap beer, pizza, steak & more.",
      "poi_long_description": "American sports bar & grill with some arcade game machines serving tap beer, pizza, steak & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-065d-742c-8033-a127df2aad6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-065d-742c-8033-a127df2aad6e",
        "storage_key": "property/5658182407946240/019e1e4b-065d-742c-8033-a127df2aad6e.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2580089528860194633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yinzers-brew--grill",
      "poi_latitude": "30.6459159",
      "poi_longitude": "-87.91173549999999",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e30b-777a-91f3-9f3e34b7169c",
        "storage_key": "property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-FCr6FDmogRSbdqsMFRziM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5acde1d2-7ac0-4a27-87b4-61f46464a8af",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "foosackly's - Daphne",
      "poi_type": "Restaurants",
      "poi_address": "29181 US-98, Daphne, AL 36526, USA",
      "poi_short_description": "Low-key local fast-food chain serving chicken fingers in boxes, on sandwiches & in salads.",
      "poi_long_description": "Low-key local fast-food chain serving chicken fingers in boxes, on sandwiches & in salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-0845-708e-a859-f367c04403b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-0845-708e-a859-f367c04403b6",
        "storage_key": "property/5658182407946240/019e1e4b-0845-708e-a859-f367c04403b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.foosacklys.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3117282072636394352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foosacklys---daphne",
      "poi_latitude": "30.6505338",
      "poi_longitude": "-87.91310969999999",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 251-375-1104",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e30b-777a-91f3-9f3e34b7169c",
        "storage_key": "property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSU63uQpDmogRcIsvbIfPQis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_f5e3d6ef-9620-4a11-87cd-d78faf288793",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "El Rancho Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "28960 US-98, Daphne, AL 36526, USA",
      "poi_short_description": "Mexican grub like fajitas & enchiladas served in a roomy space with a serene patio & cocktails.",
      "poi_long_description": "Mexican grub like fajitas & enchiladas served in a roomy space with a serene patio & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-07d9-7139-a044-9206f982d0fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-07d9-7139-a044-9206f982d0fd",
        "storage_key": "property/5658182407946240/019e1e4b-07d9-7139-a044-9206f982d0fd.webp",
        "width": 1200,
        "height": 673
      },
      "poi_business_url": "http://elranchomexicanrestaurantdaphne.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5072730545462254167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-rancho-mexican-restaurant",
      "poi_latitude": "30.6466949",
      "poi_longitude": "-87.9119667",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 251-626-2623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e30b-777a-91f3-9f3e34b7169c",
        "storage_key": "property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlbdRSqBDmogRVxqN-431ZUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_289f9b6d-ce06-4a0f-9797-232d09d26e8a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Original Oyster House",
      "poi_type": "Restaurants",
      "poi_address": "3733 Battleship Pkwy, Spanish Fort, AL 36527, USA",
      "poi_short_description": "Gulf & Southern-style seafood in wood-paneled digs with a laid-back vibe overlooking Mobile Bay.",
      "poi_long_description": "Gulf & Southern-style seafood in wood-paneled digs with a laid-back vibe overlooking Mobile Bay.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-ba95-7429-9096-d2590f3d618f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-ba95-7429-9096-d2590f3d618f",
        "storage_key": "property/5658182407946240/019e1e48-ba95-7429-9096-d2590f3d618f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.originaloysterhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12493635016438290520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "original-oyster-house",
      "poi_latitude": "30.6748095",
      "poi_longitude": "-87.95955409999999",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 251-626-2188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e30b-777a-91f3-9f3e34b7169c",
        "storage_key": "property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99b3P8JEmogRWJgvdNpOYq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f516ca37-e158-4793-be49-94820b2bc251",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "BLUEGILL Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3775 Battleship Pkwy, Spanish Fort, AL 36527, USA",
      "poi_short_description": "Rustic, waterfront hangout known for oysters, live music & sunset views of Mobile Bay.",
      "poi_long_description": "Rustic, waterfront hangout known for oysters, live music & sunset views of Mobile Bay.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-b6a1-7638-ab33-2c67f7a93b52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-b6a1-7638-ab33-2c67f7a93b52",
        "storage_key": "property/5658182407946240/019e1e48-b6a1-7638-ab33-2c67f7a93b52.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "http://www.bluegillrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13007539045512958627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bluegill-restaurant",
      "poi_latitude": "30.6748219",
      "poi_longitude": "-87.9581195",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 251-625-1998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e30b-777a-91f3-9f3e34b7169c",
        "storage_key": "property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtShKH8JEmogRo9LSUdgPhLQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_3a591f84-f8e0-4b8f-9123-a7fc50d3e753",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "27520 US-98, Daphne, AL 36526, USA",
      "poi_short_description": "Department store carrying everything from groceries and clothing to electronics and furniture.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-0b78-730d-8df7-b2f75784beee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-0b78-730d-8df7-b2f75784beee",
        "storage_key": "property/5658182407946240/019e1e4b-0b78-730d-8df7-b2f75784beee.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/934-daphne-al/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9338775983351143322&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "30.6254979",
      "poi_longitude": "-87.90589659999999",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-626-0923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e2dd-71df-8bcc-f626f05faa8b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e2dd-71df-8bcc-f626f05faa8b",
        "storage_key": "property/5658182407946240/019e1e48-e2dd-71df-8bcc-f626f05faa8b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEdIo5sdDmogRmhuYJEf_mYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_cd79393a-052d-40ed-8d87-c2c8610376de",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "27060 US-98, Daphne, AL 36526, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-0d78-72ff-8074-17337f7285c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-0d78-72ff-8074-17337f7285c3",
        "storage_key": "property/5658182407946240/019e1e4b-0d78-72ff-8074-17337f7285c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/al/daphne/27060-us-hwy-98/l987",
      "poi_directions_map_url": "https://maps.google.com/?cid=4279407355043476307&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "30.61957",
      "poi_longitude": "-87.904294",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e2e3-720d-ad08-7cbca339d35a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e2e3-720d-ad08-7cbca339d35a",
        "storage_key": "property/5658182407946240/019e1e48-e2e3-720d-ad08-7cbca339d35a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSaw0LTJDmogRU3OP7lCCYzs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_de6352fc-6679-400c-9d97-37d7f0b0cef7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "3025 US-98, Daphne, AL 36526, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-0e3a-75bf-9dc8-331086df664c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-0e3a-75bf-9dc8-331086df664c",
        "storage_key": "property/5658182407946240/019e1e4b-0e3a-75bf-9dc8-331086df664c.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3025+us+highway+98-daphne-al-36526/id=5606",
      "poi_directions_map_url": "https://maps.google.com/?cid=1999169787235182588&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "30.6188925",
      "poi_longitude": "-87.9064842",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 251-621-7266",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e313-735d-bd75-007b1006961e",
        "storage_key": "property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAUmJy1VAmogR_KfYVVR6vhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_d296f95d-0c5f-4090-b19f-d21af07a87aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Publix Super Market at Magnolia Place",
      "poi_type": "Shopping & Retail",
      "poi_address": "27955 US-98 Ste 1, Daphne, AL 36526, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-b6bd-71aa-9409-a97f13791916.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-b6bd-71aa-9409-a97f13791916",
        "storage_key": "property/5658182407946240/019e1e48-b6bd-71aa-9409-a97f13791916.webp",
        "width": 950,
        "height": 273
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1362&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=3824029252444163673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-magnolia-place",
      "poi_latitude": "30.6311555",
      "poi_longitude": "-87.9125739",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 251-626-1305",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e2e3-720d-ad08-7cbca339d35a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e2e3-720d-ad08-7cbca339d35a",
        "storage_key": "property/5658182407946240/019e1e48-e2e3-720d-ad08-7cbca339d35a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy-KT_5VDmogRWQ6jMliuETU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_ecf1550f-eb0a-49df-b3ee-b6275d30bf67",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Rouses Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3075 US-98, Daphne, AL 36526, USA",
      "poi_short_description": "Supermarket chain offering produce, meat & seafood, plus grab-&-go dinners & beer.",
      "poi_long_description": "Supermarket chain offering produce, meat & seafood, plus grab-&-go dinners & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-0cf6-761a-8d39-e89666fbe7b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-0cf6-761a-8d39-e89666fbe7b3",
        "storage_key": "property/5658182407946240/019e1e4b-0cf6-761a-8d39-e89666fbe7b3.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://www.rouses.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14771195654603958703&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rouses-market",
      "poi_latitude": "30.6195858",
      "poi_longitude": "-87.9076233",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 251-270-5006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e2e3-720d-ad08-7cbca339d35a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e2e3-720d-ad08-7cbca339d35a",
        "storage_key": "property/5658182407946240/019e1e48-e2e3-720d-ad08-7cbca339d35a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwfK_T39DmogRr2l2zC_U_cw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6205ab65-b269-4128-a037-f215d06ac53c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "27955 Highway 98 Ste Hh, 27955 US-98 Hh, Daphne, AL 36526, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-0dc6-7615-b696-d512a3d60fd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-0dc6-7615-b696-d512a3d60fd0",
        "storage_key": "property/5658182407946240/019e1e4b-0dc6-7615-b696-d512a3d60fd0.webp",
        "width": 1280,
        "height": 1002
      },
      "poi_business_url": "https://www.dollargeneral.com/?utm_source=googlebusiness&utm_medium=local&utm_campaign=localsearch_20170101",
      "poi_directions_map_url": "https://maps.google.com/?cid=769284716090416811&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "30.6310215",
      "poi_longitude": "-87.91311879999999",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 251-263-4880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e2dd-71df-8bcc-f626f05faa8b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e2dd-71df-8bcc-f626f05faa8b",
        "storage_key": "property/5658182407946240/019e1e48-e2dd-71df-8bcc-f626f05faa8b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3bGczr1DmogRq960mV8MrQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_093dc332-27c3-4377-8359-d7ebe30a18ec",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "The Fresh Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6900 US-90 Suite 2, Daphne, AL 36526, USA",
      "poi_short_description": "Upscale grocery store chain with an old-world vibe offers local produce, prepared eats, wine & more.",
      "poi_long_description": "Upscale grocery store chain with an old-world vibe offers local produce, prepared eats, wine & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-1186-7447-9ebf-f8a582e0a029.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-1186-7447-9ebf-f8a582e0a029",
        "storage_key": "property/5658182407946240/019e1e4b-1186-7447-9ebf-f8a582e0a029.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.thefreshmarket.com/al/daphne/151",
      "poi_directions_map_url": "https://maps.google.com/?cid=10113491017885380925&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-fresh-market",
      "poi_latitude": "30.653944",
      "poi_longitude": "-87.90397999999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 251-626-1422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e2e3-720d-ad08-7cbca339d35a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e2e3-720d-ad08-7cbca339d35a",
        "storage_key": "property/5658182407946240/019e1e48-e2e3-720d-ad08-7cbca339d35a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-wXhpwhDmogRPXEpSH9WWow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b5c0aafb-0b41-45fb-9d9c-009db560be75",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "T.J. Maxx",
      "poi_type": "Shopping & Retail",
      "poi_address": "6850 US-90, Daphne, AL 36526, USA",
      "poi_short_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_long_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-0f4f-7459-a08b-ca96ce65e6ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-0f4f-7459-a08b-ca96ce65e6ee",
        "storage_key": "property/5658182407946240/019e1e4b-0f4f-7459-a08b-ca96ce65e6ee.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://tjmaxx.tjx.com/store/index.jsp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17150177499692609260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tj-maxx",
      "poi_latitude": "30.652845",
      "poi_longitude": "-87.906613",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-621-1402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e2dd-71df-8bcc-f626f05faa8b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e2dd-71df-8bcc-f626f05faa8b",
        "storage_key": "property/5658182407946240/019e1e48-e2dd-71df-8bcc-f626f05faa8b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJL_4C2AVDmogR7C4TCJKrAe4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_f5ab6e3b-b263-4abd-9369-62b931fc3770",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "7100 US-90, Daphne, AL 36526, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-b670-7700-9eb5-bc9e9f4ef1ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-b670-7700-9eb5-bc9e9f4ef1ac",
        "storage_key": "property/5658182407946240/019e1e48-b670-7700-9eb5-bc9e9f4ef1ac.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Daphne/AL/Daphne/36526/863?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6468480911468732878&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "30.6535104",
      "poi_longitude": "-87.9016001",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-625-0890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e2dd-71df-8bcc-f626f05faa8b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e2dd-71df-8bcc-f626f05faa8b",
        "storage_key": "property/5658182407946240/019e1e48-e2dd-71df-8bcc-f626f05faa8b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJo3w8AwRDmogRziF9FB6pxFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_6d97a594-852c-4de3-8e81-851f922fd5a6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Daphne High School Baseball",
      "poi_type": "Education",
      "poi_address": "300 Lawson Rd, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-1343-74c8-8da4-146e67cbe510.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-1343-74c8-8da4-146e67cbe510",
        "storage_key": "property/5658182407946240/019e1e4b-1343-74c8-8da4-146e67cbe510.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6164554433962088802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daphne-high-school-baseball",
      "poi_latitude": "30.6382674",
      "poi_longitude": "-87.8622687",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 251-621-1121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e313-735d-bd75-007b1006961e",
        "storage_key": "property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1S_8y3tCmogRYpnespjljFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_406744a7-5061-459e-a8f6-769b8d16ba37",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Daphne Middle School",
      "poi_type": "Education",
      "poi_address": "1 Jody Davis Cir, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bcbe.org/dms",
      "poi_directions_map_url": "https://maps.google.com/?cid=8693604263330638933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daphne-middle-school",
      "poi_latitude": "30.6172635",
      "poi_longitude": "-87.8701882",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 251-626-2845",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e308-7779-8b9e-c05256aecf9a",
        "storage_key": "property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZXTehz5DmogRVeykTQTjpXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_980b1d72-1ea8-4a05-92f8-96b09066dd48",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "W J Carroll Intermediate School",
      "poi_type": "Education",
      "poi_address": "1000 Main St, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-1209-708d-8777-d82fb742c710.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-1209-708d-8777-d82fb742c710",
        "storage_key": "property/5658182407946240/019e1e4b-1209-708d-8777-d82fb742c710.webp",
        "width": 665,
        "height": 498
      },
      "poi_business_url": "http://www.bcbe.org/carroll",
      "poi_directions_map_url": "https://maps.google.com/?cid=8058464108067311829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "w-j-carroll-intermediate-school",
      "poi_latitude": "30.5927238",
      "poi_longitude": "-87.9019012",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 251-626-0277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e308-7779-8b9e-c05256aecf9a",
        "storage_key": "property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB8jGcnBBmogR1VCWJGlq1W8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_1bede15b-c25d-428f-8051-70e2a50834e7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Daphne Elementary School",
      "poi_type": "Education",
      "poi_address": "2307 Main St, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.daphneelementary.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18388976575921299389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daphne-elementary-school",
      "poi_latitude": "30.6125308",
      "poi_longitude": "-87.90346869999999",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 251-626-2424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e308-7779-8b9e-c05256aecf9a",
        "storage_key": "property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHVaoUsVDmogRvZ_ETsTEMv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6fddd23c-7861-4dcc-988f-244605c4e918",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Daphne East Elementary School",
      "poi_type": "Education",
      "poi_address": "26651 Co Rd 13, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-11f6-7258-a00f-10ba19205f08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-11f6-7258-a00f-10ba19205f08",
        "storage_key": "property/5658182407946240/019e1e4b-11f6-7258-a00f-10ba19205f08.webp",
        "width": 828,
        "height": 431
      },
      "poi_business_url": "http://www.daphneeast.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15206361210667501518&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daphne-east-elementary-school",
      "poi_latitude": "30.6146322",
      "poi_longitude": "-87.87008700000001",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 251-626-1663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e308-7779-8b9e-c05256aecf9a",
        "storage_key": "property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3U_eCBpCmogRzocdUPTYB9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_0e4051f6-2f42-4196-9d86-e5968d91ceb5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Belforest Elementary",
      "poi_type": "Education",
      "poi_address": "11364 Co Rd 64, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.bcbe.org/belforest",
      "poi_directions_map_url": "https://maps.google.com/?cid=14507714546926370671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belforest-elementary",
      "poi_latitude": "30.6036263",
      "poi_longitude": "-87.82911879999999",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 251-607-5624",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e308-7779-8b9e-c05256aecf9a",
        "storage_key": "property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgV5X8A9pmogRbz9Q6IPBVck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2c6b073f-1cfb-42cd-8fa3-21d9609b8019",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Bayside Academy",
      "poi_type": "Education",
      "poi_address": "303 Dryer Ave, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-12a2-743b-b0b1-43c48355fa4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-12a2-743b-b0b1-43c48355fa4a",
        "storage_key": "property/5658182407946240/019e1e4b-12a2-743b-b0b1-43c48355fa4a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.baysideacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15912210752154057404&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bayside-academy",
      "poi_latitude": "30.6022196",
      "poi_longitude": "-87.9111082",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 251-338-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e308-7779-8b9e-c05256aecf9a",
        "storage_key": "property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD5qTYd9DmogRvDpLYV-H09w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_0e9a3665-efcb-4a9d-8589-416c2f90c1ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "KinderKids Learning Center, Inc.",
      "poi_type": "Education",
      "poi_address": "10142 County Road, 25860 Friendship Rd #64, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-13c0-772d-a11d-36627a59d6fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-13c0-772d-a11d-36627a59d6fe",
        "storage_key": "property/5658182407946240/019e1e4b-13c0-772d-a11d-36627a59d6fe.webp",
        "width": 821,
        "height": 360
      },
      "poi_business_url": "http://www.kinderkidslc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16559772822039921132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kinderkids-learning-center-inc",
      "poi_latitude": "30.6018372",
      "poi_longitude": "-87.876589",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 251-626-1855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e308-7779-8b9e-c05256aecf9a",
        "storage_key": "property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgWdcsDNpmogR7IHb6qQh0OU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_ff682b64-3864-4986-9287-a87ad676685d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Neighborhood School",
      "poi_type": "Education",
      "poi_address": "26481 Kensington Pl, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://rymaps.xyz/business/neighborhood-school-2kufjz",
      "poi_directions_map_url": "https://maps.google.com/?cid=7681487690215456581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "neighborhood-school",
      "poi_latitude": "30.6108034",
      "poi_longitude": "-87.8978669",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-626-0074",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e308-7779-8b9e-c05256aecf9a",
        "storage_key": "property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0bo8utNDmogRRf_TIVsgmmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_ee6de775-ed12-4290-bb66-8f024fd94f71",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Tiny Tots Academy",
      "poi_type": "Education",
      "poi_address": "25478 Friendship Rd, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-15bf-73f3-b7b2-c90c355f2fd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-15bf-73f3-b7b2-c90c355f2fd3",
        "storage_key": "property/5658182407946240/019e1e4b-15bf-73f3-b7b2-c90c355f2fd3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://tinytotsdaphne.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3178900258663770133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tiny-tots-academy",
      "poi_latitude": "30.5969376",
      "poi_longitude": "-87.8766844",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 251-625-6625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e308-7779-8b9e-c05256aecf9a",
        "storage_key": "property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8dxAgIxBmogRFSgNVvG4HSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_9146268e-0bf4-48f9-9b00-6f309b3e7d0a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "AMC CLASSIC Jubilee Square 12",
      "poi_type": "Entertainment",
      "poi_address": "6898 US-90, Daphne, AL 36526, USA",
      "poi_short_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_long_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-15b2-7361-af3b-c2bec4ed087b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-15b2-7361-af3b-c2bec4ed087b",
        "storage_key": "property/5658182407946240/019e1e4b-15b2-7361-af3b-c2bec4ed087b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/pensacola-mobile/amc-classic-jubilee-square-12?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5193801433435880351&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-classic-jubilee-square-12",
      "poi_latitude": "30.6531512",
      "poi_longitude": "-87.9029923",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-626-5766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-5597-7244-9685-8fbf34c9fd3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e4b-5597-7244-9685-8fbf34c9fd3b",
        "storage_key": "property/5658182407946240/019e1e4b-5597-7244-9685-8fbf34c9fd3b.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJkajuHARDmogRnzvcweIWFEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_fde58e76-1531-4286-bc25-ccf2b80d9cf9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "The Wharf",
      "poi_type": "Entertainment",
      "poi_address": "23101 Canal Rd, Orange Beach, AL 36561, USA",
      "poi_short_description": "Waterfront area with shops, a marina & restaurants, as well as rides & an amphitheater.",
      "poi_long_description": "Waterfront area with shops, a marina & restaurants, as well as rides & an amphitheater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-18d2-7796-92eb-3d9dceab583a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-18d2-7796-92eb-3d9dceab583a",
        "storage_key": "property/5658182407946240/019e1e4b-18d2-7796-92eb-3d9dceab583a.webp",
        "width": 1280,
        "height": 1128
      },
      "poi_business_url": "https://alwharf.com/?utm_source=GBP&utm_medium=organic&utm_campaign=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3508481623956263118&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-wharf",
      "poi_latitude": "30.2930829",
      "poi_longitude": "-87.62887529999999",
      "poi_miles_from_property": "39.8",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "3 hours 21 mins",
      "poi_driving_minutes": "1 hour 3 mins",
      "poi_business_phone": "+1 251-224-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e313-735d-bd75-007b1006961e",
        "storage_key": "property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvfvStq0FmogRzhDmwHKhsDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_324feb1d-9b2c-47fa-92ec-c33795ca089a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "The Hangout",
      "poi_type": "Entertainment",
      "poi_address": "101 E Beach Blvd, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Colorful beach pick known for its oyster cook-off, live music & party vibe in an open-air space.",
      "poi_long_description": "Colorful beach pick known for its oyster cook-off, live music & party vibe in an open-air space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-2022-710a-8be7-a659b46d9a2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-2022-710a-8be7-a659b46d9a2a",
        "storage_key": "property/5658182407946240/019e1e4b-2022-710a-8be7-a659b46d9a2a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thehangout.com/hangout-gulf-shores/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9643066140364217520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-hangout",
      "poi_latitude": "30.2481175",
      "poi_longitude": "-87.68921519999999",
      "poi_miles_from_property": "42.4",
      "poi_walking_minutes": "15 hours 25 mins",
      "poi_biking_minutes": "3 hours 34 mins",
      "poi_driving_minutes": "58 mins",
      "poi_business_phone": "+1 251-948-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e30b-777a-91f3-9f3e34b7169c",
        "storage_key": "property/5658182407946240/019e1e48-e30b-777a-91f3-9f3e34b7169c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSU2qLbcEmogRsJwBQpAN04U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_62533926-aa88-444c-ab31-2c3a27e4d4b6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Flora-Bama",
      "poi_type": "Entertainment",
      "poi_address": "17401 Perdido Key Dr, Pensacola, FL 32507, USA",
      "poi_short_description": "Opened in 1964, this down-home waterfront bar/grill offers oysters, pub grub & live music every day.",
      "poi_long_description": "Opened in 1964, this down-home waterfront bar/grill offers oysters, pub grub & live music every day.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-215d-7653-9e00-7216209c74f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-215d-7653-9e00-7216209c74f3",
        "storage_key": "property/5658182407946240/019e1e4b-215d-7653-9e00-7216209c74f3.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.florabama.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13098639226822421918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flora-bama",
      "poi_latitude": "30.2813122",
      "poi_longitude": "-87.518213",
      "poi_miles_from_property": "48",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "4 hours 2 mins",
      "poi_driving_minutes": "1 hour 13 mins",
      "poi_business_phone": "+1 850-492-0611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-55b1-74b2-a65f-876dfe009bd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e4b-55b1-74b2-a65f-876dfe009bd9",
        "storage_key": "property/5658182407946240/019e1e4b-55b1-74b2-a65f-876dfe009bd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcqjl0mokIgRnm2_K_q2x7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_f1947582-e9ef-4309-b74e-e3c9abd79b5c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Tropic Falls at OWA",
      "poi_type": "Entertainment",
      "poi_address": "1501 S Owa Blvd, Foley, AL 36535, USA",
      "poi_short_description": "Playful theme park with 22 rides from roller coasters to spinning tea cups, plus games & shows.",
      "poi_long_description": "Playful theme park with 22 rides from roller coasters to spinning tea cups, plus games & shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-2148-75e3-a453-d3b83a7a65cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-2148-75e3-a453-d3b83a7a65cf",
        "storage_key": "property/5658182407946240/019e1e4b-2148-75e3-a453-d3b83a7a65cf.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://visitowa.com/destinations/tropic-falls-at-owa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12545438543766947597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tropic-falls-at-owa",
      "poi_latitude": "30.3737323",
      "poi_longitude": "-87.6580479",
      "poi_miles_from_property": "30.5",
      "poi_walking_minutes": "11 hours 7 mins",
      "poi_biking_minutes": "2 hours 45 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 251-923-2111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e313-735d-bd75-007b1006961e",
        "storage_key": "property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6QRAIP8OmogRDQe5EONZGq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_d1dd7976-aaaf-4f45-b592-f62110997e95",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Eastern Shore Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "29710 Urgent Care Dr, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-226d-7120-9c62-a0a41b53535c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-226d-7120-9c62-a0a41b53535c",
        "storage_key": "property/5658182407946240/019e1e4b-226d-7120-9c62-a0a41b53535c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.esucare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4908652955589704678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eastern-shore-urgent-care",
      "poi_latitude": "30.6577175",
      "poi_longitude": "-87.85139550000001",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 251-626-3782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e313-735d-bd75-007b1006961e",
        "storage_key": "property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbzD5GY1CmogR5nuYH9sJH0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_4042f8ad-c3d6-4951-8bd5-fffe2c0e083d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "27040 US-98, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-0b05-719b-8c1c-7ac80f29e1ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-0b05-719b-8c1c-7ac80f29e1ab",
        "storage_key": "property/5658182407946240/019e1e4b-0b05-719b-8c1c-7ac80f29e1ab.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/daphne-al-pharmacies/27040-hwy-98-daphne-al-36526/storeid=4959?WT.mc_id=LS_GOOGLE_RX_4959",
      "poi_directions_map_url": "https://maps.google.com/?cid=15416889699975847569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "30.6189086",
      "poi_longitude": "-87.90444",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-621-9096",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-559a-75ac-8b08-26823e784d9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e4b-559a-75ac-8b08-26823e784d9e",
        "storage_key": "property/5658182407946240/019e1e4b-559a-75ac-8b08-26823e784d9e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFXAejcVDmogRkV5w_H_L89U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_6375e142-c0f6-474b-8a52-b9facfb666c8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3025 US-98, Daphne, AL 36526, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-2782-731d-9d16-382edffbbe99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-2782-731d-9d16-382edffbbe99",
        "storage_key": "property/5658182407946240/019e1e4b-2782-731d-9d16-382edffbbe99.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3025+us+highway+98-daphne-al-36526/id=5606",
      "poi_directions_map_url": "https://maps.google.com/?cid=17037152747134282648&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "30.6190118",
      "poi_longitude": "-87.906662",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 251-621-7266",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-559a-75ac-8b08-26823e784d9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e4b-559a-75ac-8b08-26823e784d9e",
        "storage_key": "property/5658182407946240/019e1e4b-559a-75ac-8b08-26823e784d9e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbSIwtcVDmogRmGsCJSggcOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_23d61fa3-867e-4a8c-8eb7-a0dd1e8270b3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "27520 US-98, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-26cf-7044-b237-afc4b22746bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-26cf-7044-b237-afc4b22746bf",
        "storage_key": "property/5658182407946240/019e1e4b-26cf-7044-b237-afc4b22746bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/934-daphne-al/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=15579199680059638837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "30.6245952",
      "poi_longitude": "-87.90506970000001",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-626-5863",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-559a-75ac-8b08-26823e784d9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e4b-559a-75ac-8b08-26823e784d9e",
        "storage_key": "property/5658182407946240/019e1e4b-559a-75ac-8b08-26823e784d9e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxxj_RMdDmogRNYTVHpFvNNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_6ae888bc-e744-4ab3-a7cb-290b581f45ad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2020 US-98, Daphne, AL 36526, USA",
      "poi_short_description": "Neighborhood gym chain with cardio and strength-training equipment, plus group classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-297e-703b-9393-805b88f3972f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-297e-703b-9393-805b88f3972f",
        "storage_key": "property/5658182407946240/019e1e4b-297e-703b-9393-805b88f3972f.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/daphne-alabama-1667/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=1667",
      "poi_directions_map_url": "https://maps.google.com/?cid=12407025763529426311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "30.6075191",
      "poi_longitude": "-87.8978805",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-626-5018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e313-735d-bd75-007b1006961e",
        "storage_key": "property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIzxIlnlBmogRh4VKWjKcLqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2b9c61a0-1d1a-4aea-95e6-928d6691c8a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "29685 Renaissance Blvd, Daphne, AL 36526, USA",
      "poi_short_description": "Chain gym offering tanning and massage services in a low-stress environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-c4a5-70b0-b3c9-967449927346.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-c4a5-70b0-b3c9-967449927346",
        "storage_key": "property/5658182407946240/019e1e48-c4a5-70b0-b3c9-967449927346.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/daphne-al?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=13806581481807055929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "30.6588595",
      "poi_longitude": "-87.86005019999999",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 251-621-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e313-735d-bd75-007b1006961e",
        "storage_key": "property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc3cQqiQn9hQROYyYEbXUmr8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0369576d-5653-42bd-a016-0638d740015f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6900 US-90, Daphne, AL 36526, USA",
      "poi_short_description": "Full-body workouts that combine cardio with strength training in a group setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-d516-7519-bbc9-7fb38a28aa85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-d516-7519-bbc9-7fb38a28aa85",
        "storage_key": "property/5658182407946240/019e1e48-d516-7519-bbc9-7fb38a28aa85.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/daphne-alabama-0877?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=6227571355778238577&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "30.6540428",
      "poi_longitude": "-87.90296339999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-626-3767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e313-735d-bd75-007b1006961e",
        "storage_key": "property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH7ot7gVDmogRcUiPKifHbFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a374c403-6c6c-4eb5-a12b-d2e4bcdf3031",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "HOTWORX- Daphne, AL (HWY 98)",
      "poi_type": "Health and Wellness",
      "poi_address": "28600 US-98 Suite 1, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-2d07-77dc-b0b9-fc17a5d5460b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-2d07-77dc-b0b9-fc17a5d5460b",
        "storage_key": "property/5658182407946240/019e1e4b-2d07-77dc-b0b9-fc17a5d5460b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hotworx.net/studio/daphne-hwy-98?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=818273725188351510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx--daphne-al-hwy-98",
      "poi_latitude": "30.6418183",
      "poi_longitude": "-87.9116039",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 251-279-0181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e308-7779-8b9e-c05256aecf9a",
        "storage_key": "property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLXOWeaVDmogRFibjHp4XWws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_362e4937-2295-435a-b1b0-db85aeece400",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "The Yoga Hive",
      "poi_type": "Health and Wellness",
      "poi_address": "1901 Main St, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-33c7-75cf-86ac-e40bacc03a55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-33c7-75cf-86ac-e40bacc03a55",
        "storage_key": "property/5658182407946240/019e1e4b-33c7-75cf-86ac-e40bacc03a55.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://thehivepilatesandyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12611538226522773536&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-yoga-hive",
      "poi_latitude": "30.6047792",
      "poi_longitude": "-87.90295239999999",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 251-200-1688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e308-7779-8b9e-c05256aecf9a",
        "storage_key": "property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX0pqvXdDmogRIFgmvzIvBa8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_7c6e7f45-1d4a-43dd-a961-b408b32906d0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Village Point Park Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "27710 Main St, Daphne, AL 36526, USA",
      "poi_short_description": "Home to Jackson’s Oak, this storied preserve offers beach access, nature trails & picnic areas.",
      "poi_long_description": "Home to Jackson’s Oak, this storied preserve offers beach access, nature trails & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-35fd-72ea-88e6-e0cd7d63b13e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-35fd-72ea-88e6-e0cd7d63b13e",
        "storage_key": "property/5658182407946240/019e1e4b-35fd-72ea-88e6-e0cd7d63b13e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.daphneal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10909976798101439136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "village-point-park-preserve",
      "poi_latitude": "30.62880869999999",
      "poi_longitude": "-87.91184",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 251-621-3703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e2ed-7798-a3f5-9aef15761efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e2ed-7798-a3f5-9aef15761efe",
        "storage_key": "property/5658182407946240/019e1e48-e2ed-7798-a3f5-9aef15761efe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4-cOpL9DmogRoAKXJhgGaJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_5cf997eb-e7a6-4047-a3b9-b2f6d8ff5016",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Bayfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6200 Bayfront Park Dr, Daphne, AL 36526, USA",
      "poi_short_description": "A waterside park & cottage with a dock, available for parties & events of up to 300 people.",
      "poi_long_description": "A waterside park & cottage with a dock, available for parties & events of up to 300 people.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-d307-767d-9d15-e9dcd399ef73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-d307-767d-9d15-e9dcd399ef73",
        "storage_key": "property/5658182407946240/019e1e48-d307-767d-9d15-e9dcd399ef73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17200633111615010855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bayfront-park",
      "poi_latitude": "30.6305556",
      "poi_longitude": "-87.9183333",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 251-626-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e2ed-7798-a3f5-9aef15761efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e2ed-7798-a3f5-9aef15761efe",
        "storage_key": "property/5658182407946240/019e1e48-e2ed-7798-a3f5-9aef15761efe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSxB1cpRDmogRJ3iioa7stO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6540929a-ebcc-4e45-b43f-af665e7e464e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Gator Boardwalk",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "N Main St, Daphne, AL 36526, USA",
      "poi_short_description": "Park with a boardwalk featuring views of alligators, plus picnic tables, and kid-friendly hikes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-3433-770b-8415-74af09e8c6e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-3433-770b-8415-74af09e8c6e8",
        "storage_key": "property/5658182407946240/019e1e4b-3433-770b-8415-74af09e8c6e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.daphneal.com/467/Parks-Playgrounds-Bay-Access-Areas",
      "poi_directions_map_url": "https://maps.google.com/?cid=10721987581423249569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gator-boardwalk",
      "poi_latitude": "30.6515461",
      "poi_longitude": "-87.911733",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-620-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e2ed-7798-a3f5-9aef15761efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e2ed-7798-a3f5-9aef15761efe",
        "storage_key": "property/5658182407946240/019e1e48-e2ed-7798-a3f5-9aef15761efe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJsUwe7wpDmogRoejh1OUmzJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8d04de1e-8657-44c4-8f6c-7e88d5d20b96",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "May Day Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "College Ave, Daphne, AL 36526, USA",
      "poi_short_description": "Bayfront green space with a playground, fishing pier, a beach & water access for canoes & kayaks.",
      "poi_long_description": "Bayfront green space with a playground, fishing pier, a beach & water access for canoes & kayaks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-d322-76ce-8ed6-f7182c388cce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-d322-76ce-8ed6-f7182c388cce",
        "storage_key": "property/5658182407946240/019e1e48-d322-76ce-8ed6-f7182c388cce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.daphneal.com/226/Playgrounds",
      "poi_directions_map_url": "https://maps.google.com/?cid=16606858080181640792&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "may-day-park",
      "poi_latitude": "30.5993158",
      "poi_longitude": "-87.91203",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 251-621-3703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e2ed-7798-a3f5-9aef15761efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e2ed-7798-a3f5-9aef15761efe",
        "storage_key": "property/5658182407946240/019e1e48-e2ed-7798-a3f5-9aef15761efe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi2gO62BBmogRWF6N4G9pd-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_722e31cb-afd8-4a3b-8400-9223c81f982f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Centennial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1706 Main St, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-3ac1-743f-8bc0-7c578d5d9b9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-3ac1-743f-8bc0-7c578d5d9b9e",
        "storage_key": "property/5658182407946240/019e1e4b-3ac1-743f-8bc0-7c578d5d9b9e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.daphneal.com/467/Parks-Playgrounds-Bay-Access-Areas",
      "poi_directions_map_url": "https://maps.google.com/?cid=10000025860534962346&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-park",
      "poi_latitude": "30.6023137",
      "poi_longitude": "-87.90242669999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e2ed-7798-a3f5-9aef15761efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e2ed-7798-a3f5-9aef15761efe",
        "storage_key": "property/5658182407946240/019e1e48-e2ed-7798-a3f5-9aef15761efe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJm4dmlrpDmogRqgjoqYk6x4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6abf3087-781e-46a0-8cd3-bc904ff2dc1d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Slice & Dice Pickleball Lessons",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2000 Main St, Daphne, AL 36526, USA",
      "poi_short_description": "Sprawling neighborhood park offering athletic amenities, including tennis courts & softball fields.",
      "poi_long_description": "Sprawling neighborhood park offering athletic amenities, including tennis courts & softball fields.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-39f0-755e-adba-240493092851.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-39f0-755e-adba-240493092851",
        "storage_key": "property/5658182407946240/019e1e4b-39f0-755e-adba-240493092851.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.slicedicegame.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9932938516202526905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slice--dice-pickleball-lessons",
      "poi_latitude": "30.6061084",
      "poi_longitude": "-87.9024008",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 251-250-6035",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e313-735d-bd75-007b1006961e",
        "storage_key": "property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0RUANdDmogRuRgMGvTi2Ik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_4bbbd2d8-94bb-4c14-b89f-452eccc9ec8b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Al Trione Sports Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8600 Whispering Pines Rd, Daphne, AL 36526, USA",
      "poi_short_description": "Sports complex for football and soccer, plus softball and lacrosse.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-3a51-707a-9e7f-4b51416e81ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-3a51-707a-9e7f-4b51416e81ed",
        "storage_key": "property/5658182407946240/019e1e4b-3a51-707a-9e7f-4b51416e81ed.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "http://www.daphneal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4831384688098320728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "al-trione-sports-complex",
      "poi_latitude": "30.6153145",
      "poi_longitude": "-87.8750783",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 251-620-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e313-735d-bd75-007b1006961e",
        "storage_key": "property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgzhEIBZCmogRWKFcq8aGDEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_4feb68cd-3220-4b01-8155-9986accc5555",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Belrose Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Belrose Ave, Daphne, AL 36526, USA",
      "poi_short_description": "Small beach park featuring picnic tables and a bay view, accessed via steps.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-3cc1-72eb-88e4-12883f067e44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-3cc1-72eb-88e4-12883f067e44",
        "storage_key": "property/5658182407946240/019e1e4b-3cc1-72eb-88e4-12883f067e44.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.daphneal.com/facilities/facility/details/Belrose-Park-5",
      "poi_directions_map_url": "https://maps.google.com/?cid=14205120441027374226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belrose-park",
      "poi_latitude": "30.603626",
      "poi_longitude": "-87.91251849999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 251-620-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e2ed-7798-a3f5-9aef15761efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e2ed-7798-a3f5-9aef15761efe",
        "storage_key": "property/5658182407946240/019e1e48-e2ed-7798-a3f5-9aef15761efe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ8qI9N9DmogRkqwTd8e5IsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2e7f4114-6e74-4ff8-af21-122d1aec74e4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Alphonse Memorial Veterans Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7281 Park Dr, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-4028-770b-b14e-ee2ab0427f90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-4028-770b-b14e-ee2ab0427f90",
        "storage_key": "property/5658182407946240/019e1e4b-4028-770b-b14e-ee2ab0427f90.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.daphneal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16047588254627214272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alphonse-memorial-veterans-park",
      "poi_latitude": "30.6306509",
      "poi_longitude": "-87.8986783",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 251-620-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e2ed-7798-a3f5-9aef15761efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e2ed-7798-a3f5-9aef15761efe",
        "storage_key": "property/5658182407946240/019e1e48-e2ed-7798-a3f5-9aef15761efe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJM4VcGLRDmogRwDPJan58tN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cf01f244-5a6c-4e3d-a2a8-f0376cf12b93",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Baldwin County Brats",
      "poi_type": "Transportation & Transit",
      "poi_address": "18100 County Rd 54, Robertsdale, AL 36567, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://baldwincountyal.gov/departments/BRATS",
      "poi_directions_map_url": "https://maps.google.com/?cid=5459384170998902012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baldwin-county-brats",
      "poi_latitude": "30.56696269999999",
      "poi_longitude": "-87.7150881",
      "poi_miles_from_property": "15.3",
      "poi_walking_minutes": "5 hours 35 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 251-990-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-5595-775a-9caa-c6d1e23f143f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e4b-5595-775a-9caa-c6d1e23f143f",
        "storage_key": "property/5658182407946240/019e1e4b-5595-775a-9caa-c6d1e23f143f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhwErYLttmogR_KzHfPqgw0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_02498914-ee34-42bd-84fa-45f574c71834",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Fairhope Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8600 Co Rd 32, Fairhope, AL 36532, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-4537-73ef-b4ac-31ad72eed82c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-4537-73ef-b4ac-31ad72eed82c",
        "storage_key": "property/5658182407946240/019e1e4b-4537-73ef-b4ac-31ad72eed82c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://fairhopeairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1565188240250007714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairhope-airport",
      "poi_latitude": "30.4645793",
      "poi_longitude": "-87.8794429",
      "poi_miles_from_property": "12.5",
      "poi_walking_minutes": "4 hours 35 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 251-572-4626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-55c0-75c8-9ead-4bd52d60b3a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e4b-55c0-75c8-9ead-4bd52d60b3a4",
        "storage_key": "property/5658182407946240/019e1e4b-55c0-75c8-9ead-4bd52d60b3a4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJcf1krEs-mogRonC4ammquBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_3a5cdcf9-f19b-4858-b32a-b12878b02f44",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Belforest",
      "poi_type": "Transportation & Transit",
      "poi_address": "Belforest, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7271693576333468522&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belforest",
      "poi_latitude": "30.6038033",
      "poi_longitude": "-87.8524923",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e313-735d-bd75-007b1006961e",
        "storage_key": "property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLTSsCv9pmogRaqPY1Mc-6mQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_735c27d0-4eba-42de-baee-4d305ec8f7cd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Eastern Shore Centre",
      "poi_type": "Transportation & Transit",
      "poi_address": "30500 State Hwy 181, Spanish Fort, AL 36527, USA",
      "poi_short_description": "Sprawling retail complex featuring many national brands alongside local shops, eateries and entertainment options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-467e-74a5-8a38-c0eb091405ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-467e-74a5-8a38-c0eb091405ce",
        "storage_key": "property/5658182407946240/019e1e4b-467e-74a5-8a38-c0eb091405ce.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.easternshorecentre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=179076106209354698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eastern-shore-centre",
      "poi_latitude": "30.6693486",
      "poi_longitude": "-87.849159",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 251-625-0060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e2dd-71df-8bcc-f626f05faa8b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e2dd-71df-8bcc-f626f05faa8b",
        "storage_key": "property/5658182407946240/019e1e48-e2dd-71df-8bcc-f626f05faa8b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJtb_fpyFomogRymNeEsU0fAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_adc786e3-cead-4ecc-bc5b-c70c2b856661",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "City of Daphne",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1705 Main St, Daphne, AL 36526, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-46cc-71e7-ae48-e1aed5048987.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-46cc-71e7-ae48-e1aed5048987",
        "storage_key": "property/5658182407946240/019e1e4b-46cc-71e7-ae48-e1aed5048987.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.daphneal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500463446616918282&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-daphne",
      "poi_latitude": "30.6026365",
      "poi_longitude": "-87.903623",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 251-620-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-5595-775a-9caa-c6d1e23f143f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e4b-5595-775a-9caa-c6d1e23f143f",
        "storage_key": "property/5658182407946240/019e1e4b-5595-775a-9caa-c6d1e23f143f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJne_rQ5BBmogRCkn3l5LamZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_ef12bc5b-bc76-422d-8dcb-81076be0482f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Thomas Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "750 Morphy Ave, Fairhope, AL 36532, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-1f74-778f-a933-d7e0a34b139e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-1f74-778f-a933-d7e0a34b139e",
        "storage_key": "property/5658182407946240/019e1e4b-1f74-778f-a933-d7e0a34b139e.webp",
        "width": 1024,
        "height": 682
      },
      "poi_business_url": "https://www.infirmaryhealth.org/hospitals/thomas-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=12574050792226481232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thomas-hospital",
      "poi_latitude": "30.5188245",
      "poi_longitude": "-87.8896512",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 251-928-2375",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e33e-778a-8c6f-21076aff403b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e33e-778a-8c6f-21076aff403b",
        "storage_key": "property/5658182407946240/019e1e48-e33e-778a-8c6f-21076aff403b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJoSo5c3tAmogRUORgSpMAgK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_a23eb7c9-ec74-427d-b1e2-6c0a1b87f0fd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Austal USA",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Austal Wy, Mobile, AL 36602, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-4937-729e-af82-194b15ed829d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-4937-729e-af82-194b15ed829d",
        "storage_key": "property/5658182407946240/019e1e4b-4937-729e-af82-194b15ed829d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://austalusa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10975448537163320832&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "austal-usa",
      "poi_latitude": "30.6896681",
      "poi_longitude": "-88.02754670000002",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 251-434-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e313-735d-bd75-007b1006961e",
        "storage_key": "property/5658182407946240/019e1e48-e313-735d-bd75-007b1006961e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh_fW2N5PmogRAE4zTEugUJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_f4ed76b0-5372-410f-9c66-b5b5383cb5c3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Baldwin County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Courthouse Square, Bay Minette, AL 36507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-4cb9-70aa-ae5b-ac884de572c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e4b-4cb9-70aa-ae5b-ac884de572c2",
        "storage_key": "property/5658182407946240/019e1e4b-4cb9-70aa-ae5b-ac884de572c2.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://baldwincountyal.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14877037714024404608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baldwin-county-courthouse",
      "poi_latitude": "30.8831293",
      "poi_longitude": "-87.7741705",
      "poi_miles_from_property": "26.8",
      "poi_walking_minutes": "9 hours 52 mins",
      "poi_biking_minutes": "2 hours 14 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 251-937-9561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e4b-5595-775a-9caa-c6d1e23f143f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e4b-5595-775a-9caa-c6d1e23f143f",
        "storage_key": "property/5658182407946240/019e1e4b-5595-775a-9caa-c6d1e23f143f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH6k11_iJmogRgJaDnvradc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_abc65fae-2e01-45de-bb42-377826791385",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "poi_name": "Baldwin County Public Schools",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2600 North Hand Ave, Bay Minette, AL 36507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.bcbe.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10418085452426939540&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baldwin-county-public-schools",
      "poi_latitude": "30.9125347",
      "poi_longitude": "-87.78756369999999",
      "poi_miles_from_property": "28.9",
      "poi_walking_minutes": "10 hours 41 mins",
      "poi_biking_minutes": "2 hours 28 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 251-937-0306",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-e308-7779-8b9e-c05256aecf9a",
        "storage_key": "property/5658182407946240/019e1e48-e308-7779-8b9e-c05256aecf9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-f-CazCKmogRlIySh4V5lJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_bb1559d6-0a13-4904-a154-4e36e724989f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_1b8e4548-1bdb-46ad-9ace-e205b310f4ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_452ef48f-6da5-4178-8ce0-40e6e56adb19",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_1582637f-9ca6-41a6-bc56-45e2d4f031ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_adf0980a-5f4e-4b21-ba2e-991547a8782f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_cbe13a79-a1b4-47e7-9e21-28d6c2a29b2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "rating": "5.0",
      "name": "Christopher Long",
      "text": "I am new to Daphne and stopped by Windscape looking for a one bedroom apartment. Although they did not have any available apartments to view, Theresa went out of her way to walk me around the property which was so peaceful and beautiful and even took the time to show me a virtual tour on the website so I could get a better sense of the layout and features of the one bedroom floorplan. Theresa was incredibly friendly, patient, and genuinely helpful throughout the visit. It really stood out that she was willing to spend that time with me even though there wasn't an immediate available apartment to rent. That level of care and professionalism says a lot about how they treat potential tenants. I only wish they had something available because I would have felt very comfortable living here.",
      "date": "2026-04-21",
      "title": ""
    },
    {
      "id": "custom_789007d5-4913-4b69-b138-4916526c8bd9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "rating": "5.0",
      "name": "M.A.C. production",
      "text": "I’ve lived in these apartments twice; great community. Absolutely the best apartment manager in the world. Theresa genuinely cares about her tenants, is reasonable on requests and normally easy to get in touch with. She really makes these apartments worth it. I can’t express enough how much she’s helped me, my family and my loved ones in the past living at these apartments. If I could I’d give this a 10/10",
      "date": "2026-04-07",
      "title": ""
    },
    {
      "id": "custom_b70215e3-5b82-42aa-935e-69296e296ccf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "rating": "5",
      "name": "Susan Dotson",
      "text": "I've just renewed my lease for the 2nd time. Windscape has a great Daphne location and is well managed by Theresa Mares. I highly recommend it if you are looking for a good, quiet place to live.",
      "date": "2026-03-06",
      "title": "false"
    },
    {
      "id": "custom_ed3602bf-6978-4c92-8404-aa19fe7288bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "rating": "5",
      "name": "Jeffrey Pierce",
      "text": "Kyra Pierce’s professionalism and attentiveness to my questions and concerns is indicative of the quality of personnel at ONETen.\n\nThey are the best!!!",
      "date": "2026-02-20",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_250f5801-61e8-4f30-86b6-6ed328e4c8f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019e6789-8318-71d7-955c-a786f43dad96.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e6789-8318-71d7-955c-a786f43dad96",
        "storage_key": "property/5658182407946240/019e6789-8318-71d7-955c-a786f43dad96.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Entrance",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6668b2925fd35b2fe886dd98"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a187e-0787-7212-a2d2-77aae1e1eaea",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-windscape-at-daphne-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240"
    },
    {
      "lead_collector_id": "019a502e-c5a7-76e4-815e-6413442f5fd2",
      "lead_source": "LANDING_PAGE",
      "name": "rr-living-windscape-at-daphne-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240"
    },
    {
      "lead_collector_id": "01a0a18a-48e1-7378-98e6-49d30a860206",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "generator",
      "page_item_url": "apartments-with-pool-daphne-al",
      "search_query": "apartments with pool in Daphne AL",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Daphne, AL",
      "h2_subtitle": "Discover modern apartments with a pool in Daphne, AL. Enjoy luxury amenities and a vibrant lifestyle at Windscape at Daphne.",
      "page_copy": "Discover the ideal lifestyle at Windscape at Daphne, where we offer apartments with a pool in Daphne, AL. Our inviting community combines modern amenities like walking and biking trails, a state-of-the-art fitness center, and a relaxing roof terrace, perfect for enjoying Alabama's beautiful weather. \n\nOur one and two-bedroom floor plans are designed with your comfort in mind, featuring everything from microwaves to spacious patios. Dive into relaxation at our community pool or stay active at the fitness center, all while enjoying the peace of mind that comes with 24-hour access. Join us at Windscape at Daphne and embrace your new home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019d06fa-763f-733e-962e-456fdfaec87a.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
        "public_id": "019d06fa-763f-733e-962e-456fdfaec87a",
        "storage_key": "property/5658182407946240/019d06fa-763f-733e-962e-456fdfaec87a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Daphne, AL",
      "seo_description": "Explore Windscape at Daphne, offering modern apartments with a pool in Daphne, AL. Schedule a tour of our vibrant community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-biking-trails-daphne",
      "search_query": "pet friendly apartments with biking trails Daphne",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Biking Trails",
      "h2_subtitle": "Explore pet-friendly living with biking trails in Daphne. Windscape at Daphne is perfect for you and your furry friends.",
      "page_copy": "Welcome to Windscape at Daphne, the perfect pet-friendly community in Daphne, where scenic biking trails await right outside your door. Our one and two-bedroom apartments are designed with both you and your furry friends in mind, offering comfortable living spaces complete with amenities like patios and microwaves.\n\nEnjoy a unique lifestyle offering a blend of relaxation and activity. Take a peaceful stroll or an exhilarating bike ride on our trails, and when it's time to unwind, our refreshing pool and roof terrace are at your disposal. Plus, with amenities like a state-of-the-art fitness center and 24-hour access, every need is met. Come see why Windscape at Daphne is the ideal home for you and your pets!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019d06fa-763f-733e-962e-456fdfaec87a.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
        "public_id": "019d06fa-763f-733e-962e-456fdfaec87a",
        "storage_key": "property/5658182407946240/019d06fa-763f-733e-962e-456fdfaec87a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Biking Trails",
      "seo_description": "Windscape at Daphne offers pet-friendly apartments with biking trails. Perfect for you and your pets. Discover this vibrant community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "generator",
      "page_item_url": "high-speed-internet-apartments-daphne-36526",
      "search_query": "high-speed internet apartments Daphne 36526",
      "category": "Amenity",
      "h1_title": "High-Speed Internet Apartments in Daphne",
      "h2_subtitle": "Find apartments with high-speed internet in Daphne 36526. Windscape at Daphne offers the connectivity you need.",
      "page_copy": "At Windscape at Daphne, staying connected is easy with high-speed internet available in all our apartments in the 36526 area. Our community offers one and two-bedroom floor plans designed to meet modern needs, providing a seamless living experience with digital efficiency.\n\nBesides exceptional connectivity, residents enjoy wonderful amenities such as a state-of-the-art fitness center, a relaxing pool, and scenic biking trails. With the convenience of 24-hour access and features like microwaves and patios in every unit, Windscape at Daphne ensures a perfect blend of technology and comfort in the heart of Daphne. Don't miss out—schedule a tour today and experience our vibrant community!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019d06fa-763f-733e-962e-456fdfaec87a.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
        "public_id": "019d06fa-763f-733e-962e-456fdfaec87a",
        "storage_key": "property/5658182407946240/019d06fa-763f-733e-962e-456fdfaec87a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "High-Speed Internet Apartments in Daphne",
      "seo_description": "Discover Windscape at Daphne's apartments with high-speed internet in the 36526 area. Enjoy modern living with exceptional connectivity today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "generator",
      "page_item_url": "apartments-with-business-center-baldwin-county",
      "search_query": "apartments with business center Baldwin County",
      "category": "Amenity",
      "h1_title": "Apartments with Business Center in Baldwin County",
      "h2_subtitle": "Discover apartments with a business center in Baldwin County. Windscape at Daphne offers a convenient lifestyle for busy professionals.",
      "page_copy": "Windscape at Daphne, located in the heart of Baldwin County, offers more than just comfortable living spaces; our community provides apartments with a business center, perfect for those balancing work and home life. Our one and two-bedroom floor plans are equipped with modern amenities, ensuring convenience and comfort in every square foot.\n\nIn addition to the business center, residents can enjoy our refreshing pool, state-of-the-art fitness center, and scenic biking trails, all designed to enhance your wellness and relaxation. With features like microwaves, patios, and 24-hour access, Windscape at Daphne stands out as a premier community in Baldwin County. Embrace a seamless lifestyle—visit us today and see why our community is the ideal place to call home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019d06fa-763f-733e-962e-456fdfaec87a.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
        "public_id": "019d06fa-763f-733e-962e-456fdfaec87a",
        "storage_key": "property/5658182407946240/019d06fa-763f-733e-962e-456fdfaec87a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Business Center in Baldwin County",
      "seo_description": "Explore Windscape at Daphne, offering apartments with a business center in Baldwin County. Perfect for work and relaxation—visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-with-fireplace-daphne",
      "search_query": "smoke free apartments with fireplace Daphne",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments with Fireplace in Daphne",
      "h2_subtitle": "Experience cozy, smoke-free living with a fireplace in Daphne. Discover the comforts of Windscape at Daphne today.",
      "page_copy": "Discover the comfort of smoke-free living at Windscape at Daphne, where our thoughtfully designed apartments offer the warm ambiance of a fireplace. Our one and two-bedroom floor plans cater to residents seeking a serene and healthy environment in the charming city of Daphne.\n\nWindscape at Daphne doesn't just stop at cozy interiors. Our vibrant community features a refreshing pool, a state-of-the-art fitness center, and beautiful biking trails. Relax on our patios or take a stroll around our well-designed premises, enjoying amenities that cater to various lifestyles. Schedule a tour today to experience a perfect blend of comfort and convenience in a smoke-free setting!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019d06fa-763f-733e-962e-456fdfaec87a.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
        "public_id": "019d06fa-763f-733e-962e-456fdfaec87a",
        "storage_key": "property/5658182407946240/019d06fa-763f-733e-962e-456fdfaec87a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments with Fireplace in Daphne",
      "seo_description": "Windscape at Daphne offers smoke-free apartments with a fireplace. Enjoy cozy living in a serene setting. Discover your perfect home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-daphne-al",
      "search_query": "1 bedroom apartments Daphne AL",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Daphne, AL",
      "h2_subtitle": "Explore our 1 bedroom apartments in Daphne, AL at Windscape. Discover the perfect blend of comfort and style.",
      "page_copy": "Windscape at Daphne invites you to explore our exquisite 1 bedroom apartments in Daphne, AL. Our thoughtfully crafted floor plans offer an ideal balance of comfort and modern living, providing the perfect space for singles and couples alike.\n\nResidents enjoy access to a range of upscale amenities, including a refreshing pool, a fully-equipped fitness center, and scenic walking trails. Each apartment boasts cozy features like patios and convenient in-unit amenities such as microwaves. With a focus on quality and lifestyle, Windscape at Daphne ensures your new home is both welcoming and functional. Schedule a tour today and see why our community is a sought-after choice in Daphne!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019d06fa-763f-733e-962e-456fdfaec87a.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
        "public_id": "019d06fa-763f-733e-962e-456fdfaec87a",
        "storage_key": "property/5658182407946240/019d06fa-763f-733e-962e-456fdfaec87a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Daphne, AL",
      "seo_description": "Discover 1 bedroom apartments at Windscape in Daphne, AL. Enjoy comfort and modern amenities. Schedule your visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "5658182407946240",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-36526",
      "search_query": "2 bedroom apartments near 36526",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near 36526",
      "h2_subtitle": "Find spacious 2 bedroom apartments near the 36526 area at Windscape at Daphne. Discover comfort and convenience today.",
      "page_copy": "At Windscape at Daphne, we offer comfortable and spacious 2 bedroom apartments near the 36526 zip code. Our apartments are designed with modern amenities and thoughtful floor plans, making them perfect for families, roommates, or those needing extra space.\n\nLocated in the vibrant community of Daphne, residents will appreciate amenities such as a refreshing pool, a cutting-edge fitness center, and stunning walking trails. Whether you're relaxing on your private patio or enjoying the convenient features like in-unit microwaves, our community ensures a blend of comfort and functionality. Schedule a tour and experience why our 2 bedroom apartments are a top choice in the 36526 area!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5658182407946240/019d06fa-763f-733e-962e-456fdfaec87a.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
        "public_id": "019d06fa-763f-733e-962e-456fdfaec87a",
        "storage_key": "property/5658182407946240/019d06fa-763f-733e-962e-456fdfaec87a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near 36526",
      "seo_description": "Discover spacious 2 bedroom apartments near 36526 at Windscape. Enjoy modern living with exceptional amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3418"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483324"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973403"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N4GQC6WJ"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "251-336-4234"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "251-336-4097"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "251-336-4167"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "251-336-4176"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "251-325-1826"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "251-325-1923"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "251-336-4168"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "251-336-4099"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "251-325-1689"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "251-351-0221"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "251-322-3530"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "251-336-4218"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "251-360-3557"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "251-360-3631"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "251-276-4308"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "251-278-2367"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "251-309-7119"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "251-351-1382"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321263911"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "251-325-1934"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "251-512-3731"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "e3d31b970114311e"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "251-766-1086"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "251-325-1969"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "251-297-3743"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "251-309-5883"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "251-336-4116"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "251-297-3745"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "251-325-1639"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.windscapeatdaphne.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/5658182407946240/019e849a-93bb-7303-a017-3ebaae2a1749.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "251-325-1813"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "251-351-0221"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3418",
  "custom_repli_id": "5028483324",
  "custom_realpage_id": "4973403",
  "custom_knock_a_link": "https://www.windscapeatdaphne.com?utm_knock=a",
  "custom_knock_g_link": "https://www.windscapeatdaphne.com?utm_knock=g",
  "custom_knock_r_link": "https://www.windscapeatdaphne.com?utm_knock=r",
  "custom_knock_w_link": "https://www.windscapeatdaphne.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-N4GQC6WJ",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.windscapeatdaphne.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.windscapeatdaphne.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.windscapeatdaphne.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.windscapeatdaphne.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.windscapeatdaphne.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.windscapeatdaphne.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "251-336-4234",
  "custom_knock_ads_link": "https://www.windscapeatdaphne.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.windscapeatdaphne.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "251-336-4097",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.windscapeatdaphne.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.windscapeatdaphne.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.windscapeatdaphne.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.windscapeatdaphne.com?utm_knock=psa",
  "custom_knock_r_number": "251-336-4167",
  "custom_knock_w_number": "251-336-4176",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "251-325-1826",
  "custom_knock_amap_link": "https://www.windscapeatdaphne.com?utm_knock=amap",
  "custom_knock_ar_number": "251-325-1923",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "251-336-4168",
  "custom_knock_fb_number": "251-336-4099",
  "custom_knock_fl_number": "251-325-1689",
  "custom_knock_gp_number": "251-351-0221",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.windscapeatdaphne.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "251-322-3530",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.windscapeatdaphne.com?utm_knock=bcard",
  "custom_knock_bnr_number": "251-336-4218",
  "custom_knock_cfres_link": "https://www.windscapeatdaphne.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "251-360-3557",
  "custom_knock_lgp_number": "251-360-3631",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.windscapeatdaphne.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "251-276-4308",
  "custom_knock_psa_number": "251-278-2367",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "251-309-7119",
  "custom_knock_bandit_link": "https://www.windscapeatdaphne.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.windscapeatdaphne.com?utm_knock=flyers",
  "custom_knock_osoc_number": "251-351-1382",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321263911",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "251-325-1934",
  "custom_knock_cfres_number": "251-512-3731",
  "custom_knock_chatgpt_link": "https://www.windscapeatdaphne.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "e3d31b970114311e",
  "custom_knock_dirmail_link": "https://www.windscapeatdaphne.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "251-766-1086",
  "custom_knock_propbro_link": "https://www.windscapeatdaphne.com?utm_knock=propbro",
  "custom_knock_bandit_number": "251-325-1969",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "251-297-3743",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.windscapeatdaphne.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "251-309-5883",
  "custom_knock_dirmail_number": "251-336-4116",
  "custom_knock_propbro_number": "251-297-3745",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "251-325-1639",
  "custom_knock_maintenance_link": "https://www.windscapeatdaphne.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/5658182407946240/019e849a-93bb-7303-a017-3ebaae2a1749.mp4",
  "custom_knock_maintenance_number": "251-325-1813",
  "custom_ppc_tracking_phone_number": "251-351-0221"
};

export const generatedAt = '2026-10-07T17:16:15.912Z';
